import * as React from 'react';
import React__default, { Fragment } from 'react';
import PropTypes from 'prop-types';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

const EmailSVG = _ref => {
  let {
    fill,
    width,
    height,
    title
  } = _ref;
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: fill,
    width: width,
    height: height,
    viewBox: "0 0 28.99 19.57"
  }, /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React__default.createElement("path", {
    id: "Icon_zocial-email",
    "data-name": "Icon zocial-email",
    d: "M0,17.84V1.73s0-.19.08-.53L9.56,9.31.11,18.4A2.14,2.14,0,0,1,0,17.84ZM1.26.08A1.26,1.26,0,0,1,1.73,0H27.26a1.69,1.69,0,0,1,.5.08l-9.5,8.14L17,9.23l-2.49,2L12,9.23l-1.26-1Zm0,19.41,9.53-9.14,3.69,3,3.69-3,9.54,9.14a1.61,1.61,0,0,1-.48.08H1.73A1.32,1.32,0,0,1,1.29,19.49ZM19.46,9.31,28.91,1.2a1.37,1.37,0,0,1,.08.53V17.84a2.1,2.1,0,0,1-.08.56Z"
  }))));
};

const QuestionMarkSVG = _ref => {
  let {
    fill,
    width,
    height,
    title
  } = _ref;
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29 29",
    width: width,
    height: height
  }, /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Group_68",
    "data-name": "Group 68"
  }, /*#__PURE__*/React__default.createElement("circle", {
    cx: "14.5",
    cy: "14.5",
    r: "14.5",
    fill: fill
  })), /*#__PURE__*/React__default.createElement("path", {
    fill: "#fff",
    d: "M13.12,19V17.45c0-1.68.36-2.1,1.51-3.27L16.78,12a2.49,2.49,0,0,0,.7-1.82A2.39,2.39,0,0,0,15,7.71a2.86,2.86,0,0,0-2.8,2.74l-3.58-.28A6.13,6.13,0,0,1,15.1,4.52C18.44,4.52,21,6.45,21,10c0,2.43-1.43,3.61-3.05,5.15-1,1-1.48,1.34-1.48,2.8V19ZM14.8,20.7A2.2,2.2,0,0,1,17,22.83,2.24,2.24,0,1,1,14.8,20.7Z"
  }))));
};

const SecureIconSVG = _ref => {
  let {
    fill,
    width,
    height,
    title
  } = _ref;
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.75 28.5",
    fill: fill,
    height: height,
    width: width
  }, /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M19.35,11.73H18V7.62a7.62,7.62,0,0,0-15.24,0v4.11H1.41A1.41,1.41,0,0,0,0,13.14v14A1.41,1.41,0,0,0,1.41,28.5H19.35a1.41,1.41,0,0,0,1.4-1.41V13.14A1.41,1.41,0,0,0,19.35,11.73ZM5.57,7.62a4.81,4.81,0,1,1,9.61,0v4.11H5.57Z"
  }))));
};

const CaretDownSVG = _ref => {
  let {
    fill,
    width,
    height,
    title
  } = _ref;
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 8",
    fill: fill,
    width: width,
    height: height
  }, /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React__default.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    d: "M6,8,0,0H12Z"
  }))));
};

const SuccessIconSVG = _ref => {
  let {
    fill,
    width,
    height,
    title
  } = _ref;
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 149.53 118.38",
    fill: fill,
    width: width,
    height: height
  }, /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M126.39,0,56.07,72.07,23.14,40.85,0,64l56.07,54.38,93.46-95.23Z"
  }))));
};

const InformationIconSVG = _ref => {
  let {
    fill,
    width,
    height,
    title
  } = _ref;
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.5 28.5",
    width: width,
    height: height
  }, /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: fill,
    d: "M14.25,0A14.25,14.25,0,1,0,28.5,14.25,14.25,14.25,0,0,0,14.25,0Zm3,22.08c-.74.29-1.32.51-1.76.66a4.42,4.42,0,0,1-1.52.23,3,3,0,0,1-2.07-.65,2.07,2.07,0,0,1-.74-1.65,7.13,7.13,0,0,1,0-.79c0-.27.1-.58.18-.92l.92-3.24c.08-.31.15-.61.21-.88a4.37,4.37,0,0,0,.08-.76,1.17,1.17,0,0,0-.26-.87,1.47,1.47,0,0,0-1-.24,2.35,2.35,0,0,0-.73.11c-.25.07-.46.14-.64.21l.25-1c.6-.25,1.17-.46,1.72-.63a5.3,5.3,0,0,1,1.56-.26,3,3,0,0,1,2,.64,2.13,2.13,0,0,1,.71,1.66,6.8,6.8,0,0,1,0,.74,4.74,4.74,0,0,1-.18,1l-.91,3.23a7.94,7.94,0,0,0-.2.89,4.67,4.67,0,0,0-.09.76,1,1,0,0,0,.29.87,1.56,1.56,0,0,0,1,.24,2.77,2.77,0,0,0,.76-.12,4.81,4.81,0,0,0,.61-.2ZM17.05,9a2.15,2.15,0,0,1-1.53.6A2.2,2.2,0,0,1,14,9a1.88,1.88,0,0,1-.64-1.44A1.93,1.93,0,0,1,14,6.08a2.2,2.2,0,0,1,1.55-.6,2.15,2.15,0,0,1,1.53.6,1.89,1.89,0,0,1,.64,1.44A1.86,1.86,0,0,1,17.05,9Z"
  }))));
};

const WarningIconSVG = _ref => {
  let {
    fill,
    width,
    height,
    title
  } = _ref;
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.08 32.09",
    width: width,
    height: height
  }, /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: fill,
    d: "M22,0H9.1L0,9.4V22.69l9.1,9.4H22l9.11-9.4V9.4ZM13.34,5.15H18V19.77H13.34Zm2.31,22a2.84,2.84,0,1,1,2.84-2.84A2.84,2.84,0,0,1,15.65,27.18Z"
  }))));
};

const CautionIconSVG = _ref => {
  let {
    fill,
    width,
    height,
    title
  } = _ref;
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29 29",
    width: width,
    height: height
  }, /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: fill,
    d: "M14.5,0A14.5,14.5,0,1,0,29,14.5,14.5,14.5,0,0,0,14.5,0ZM12.82,4.55h3.36v13.6H12.82Zm1.8,20.16a2.24,2.24,0,0,1-.24-4.48h.12a2.19,2.19,0,0,1,2.24,2.12h0A2.24,2.24,0,0,1,14.62,24.71Z"
  }))));
};

const StarSVG = _ref => {
  let {
    fill,
    width,
    height,
    title
  } = _ref;
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 25 25",
    focusable: "false"
  }, /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("polygon", {
    fill: fill,
    points: "25 9.12 15.5669599 9.12 12.512219 0 9.40860215 9.12 0 9.12 7.55131965 14.856 4.47214076 24 12.512219 18.216 20.5522972 24 17.4731183 14.856"
  }));
};

const LeftArrowSVG = _ref => {
  let {
    fill,
    width,
    height,
    title
  } = _ref;
  return /*#__PURE__*/React__default.createElement("svg", {
    viewBox: "0 0 100 100",
    width: width,
    height: height
  }, /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("path", {
    fill: fill,
    d: "M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z"
  }));
};

const RightArrowSVG = _ref => {
  let {
    fill,
    width,
    height,
    title
  } = _ref;
  return /*#__PURE__*/React__default.createElement("svg", {
    viewBox: "0 0 100 100",
    width: width,
    height: height
  }, /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("path", {
    fill: fill,
    d: "M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z",
    transform: "translate(100, 100) rotate(180) "
  }));
};

const UpArrowSVG = _ref => {
  let {
    fill,
    width,
    height,
    title
  } = _ref;
  return /*#__PURE__*/React__default.createElement("svg", {
    viewBox: "0 0 100 100",
    width: width,
    height: height
  }, /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("path", {
    fill: fill,
    d: "M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z",
    transform: "translate(100, 30) rotate(90) "
  }));
};

const DownArrowSVG = _ref => {
  let {
    fill,
    width,
    height,
    title
  } = _ref;
  return /*#__PURE__*/React__default.createElement("svg", {
    viewBox: "0 0 100 100",
    width: width,
    height: height
  }, /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("path", {
    fill: fill,
    d: "M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z",
    transform: "translate(0, 110) rotate(270)"
  }));
};

const PlusIconSVG = _ref => {
  let {
    fill,
    width,
    height,
    title
  } = _ref;
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.44 16.44",
    fill: fill,
    width: width,
    height: height
  }, /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0,6.33H6.33V0h3.78V6.33h6.33v3.78H10.11v6.33H6.33V10.11H0Z"
  }))));
};

const MinusIconSVG = _ref => {
  let {
    fill,
    width,
    height,
    title
  } = _ref;
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 3.6",
    fill: fill,
    width: width,
    height: height
  }, /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0,0H15V3.6H0Z"
  }))));
};

const RemoveIconSVG = _ref => {
  let {
    fill,
    width,
    height,
    title
  } = _ref;
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 21",
    fill: fill,
    width: width,
    height: height
  }, /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React__default.createElement("path", {
    "data-name": "Icon material-close",
    d: "M21,2.11,18.89,0,10.5,8.39,2.11,0,0,2.11,8.39,10.5,0,18.89,2.11,21l8.39-8.39L18.89,21,21,18.89,12.61,10.5Z"
  }))));
};

const UserIconSVG = _ref => {
  let {
    fill,
    width,
    height,
    title
  } = _ref;
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 409.17 405.33",
    fill: fill,
    width: width,
    height: height
  }, /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M204.58,214.75c50.67,0,91.74-48.07,91.74-107.37C296.32,25.14,255.25,0,204.58,0s-91.74,25.14-91.74,107.38C112.84,166.68,153.92,214.75,204.58,214.75Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M407.16,372.8,360.88,268.54a23.29,23.29,0,0,0-10.46-11.14L278.59,220a4.65,4.65,0,0,0-4.93.41,113.31,113.31,0,0,1-138.15,0,4.62,4.62,0,0,0-4.93-.41L58.75,257.4a23.15,23.15,0,0,0-10.46,11.14L2,372.8a23.14,23.14,0,0,0,21.15,32.53H386a23.14,23.14,0,0,0,21.15-32.53Z"
  }))));
};

const ArcteryxLogo = _ref => {
  let {
    width,
    height,
    title
  } = _ref;
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 106.917 65"
  }, /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("g", {
    transform: "translate(0 -15.852)"
  }, /*#__PURE__*/React__default.createElement("g", {
    transform: "translate(0 15.852)"
  }, /*#__PURE__*/React__default.createElement("g", {
    transform: "translate(24.519)"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M236.336,389.237c.159-.091.316-.186.475-.266.582-.189.833-.9,1.508-.832.612-.692,1.524-.849,2.232-1.4a.807.807,0,0,1,.229-.361c.447-.339-.3-.6-.3-.6-.218-.291-.549-.025-.549-.025a3.853,3.853,0,0,1-.511.267c-.095.33-.439.361-.69.5a6.5,6.5,0,0,1-1.274.864c-.317.476-.876.563-1.243.923a1.766,1.766,0,0,0-.591.658s-.872.8.288.363Z",
    transform: "translate(-230.492 -362.974)"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M222.533,402.217a.538.538,0,0,1-.062.086.08.08,0,0,1-.042.032,5.366,5.366,0,0,0-1.316,1.551,4.887,4.887,0,0,1-1.469,1.622c-.5,0-.786.518-1.21.721-.126-.031-.156-.173-.219-.267a1.561,1.561,0,0,1-.154-.981,1.427,1.427,0,0,0,.719-.369c.274-.231.543-.476.812-.727.828-.774,1.638-1.614,2.456-2.337C222.047,401.549,222.677,401.249,222.533,402.217Z",
    transform: "translate(-217.769 -374.657)"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M222.434,397.262c-.941.377-2.057.377-2.795,1.131-.346.189-.943-.141-1.163.3.063.11.016.283.031.409l-.344-.032.078.676c.832.11,1.272-.958,2.073-1.053l.111.11v.236c-.127.078-.3-.125-.441,0a4.385,4.385,0,0,1-1.477,1.006c-.126.075-.131.33-.255.35l-.123.938c.466.113.8-.257,1.141-.569a2.644,2.644,0,0,1,.258-.216,23.682,23.682,0,0,0,2.561-2.608S222.333,398.089,222.434,397.262Z",
    transform: "translate(-217.843 -371.533)"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M292.2,393.729a4.09,4.09,0,0,1-1.307,3.077c-.848.22-1.681.848-2.561.33-.551-.3-1.209.032-1.617-.6-.189-.063-.455-.016-.534-.267.108-.267.463-.271.665-.46,1.006.125,2.279.927,3.157.032.379-.173.944-.22.99-.754a1.092,1.092,0,0,1,.379-.911c.31-.013.351-.387.447-.659,0,0-.028-.953.335-.808,0,0,.333.352,0,.58Z",
    transform: "translate(-267.952 -368.172)"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M267.409,377.041c-.308.289-.644.557-.794.715a5.468,5.468,0,0,1-3.958.157c-.172-.3.324-.426.024-.709.112-.11.166-.223.339-.16.172.472.7.24,1.066.3.518.189.96-.188,1.429-.11.331-.157.5-.157.834-.314a.346.346,0,0,0,.19-.036S267.627,376.185,267.409,377.041Z",
    transform: "translate(-250.604 -356.33)"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M342.237,329.182c-.58-.533-1.069.211-1.069.211a1.172,1.172,0,0,0-.414.511c-.785.377-1.131,1.414-1.932,1.728-.485.487-1.083.8-1.617,1.351a19.457,19.457,0,0,0-3.425.942c-.8.314-1.665.455-2.45.754-.959.644-2.074.864-3.017,1.509-.158.142-.536.22-.424.533.141.22.424.047.612.157.188.126.614.079.6.409-.2.188-.642.173-.6.566a7.209,7.209,0,0,0,1.194.6,8.442,8.442,0,0,0,1.661.907c.984.418,2.019.72,2.989,1.166a10.2,10.2,0,0,1,2.324.691c.912.251,1.9.55,2.874.754.6.236.034.755.143,1.194-.017.3-.267.534-.143.833a3.672,3.672,0,0,0-.422,2.419c-.236.094-.128.345-.063.487a4.7,4.7,0,0,0-.379,1.477c-.108-.032-.172.078-.188.141-.078.722-.155,1.288-.235,2a1.725,1.725,0,0,0,1.429-.112c-.252-.534.156-.99.125-1.539.172-.33.047-.644.142-1.021a18.908,18.908,0,0,0,.565-4.116c-.063-.22-.235-.393.079-.565l.157.157c-.125.487.079,1.021-.048,1.477.315.957.033,2.026.19,3.047.658.361-.2,1.068.456,1.429a.753.753,0,0,0,.244.61,1.122,1.122,0,0,0,1-.453c.095-.927-.44-1.586-.455-2.45-.206-.6-.094-1.163-.441-1.7-.015-.519-.219-1.037-.266-1.556-.267-.22-.142-.675-.111-.974-.094-.55-.062-1.335-.753-1.587a24.027,24.027,0,0,1-3.441-.895c-.691-.142-1.365-.534-2.1-.644a6.791,6.791,0,0,0-.778-.271,8.841,8.841,0,0,1-1.91-.673c-.161-.044-.318-.1-.476-.149a.926.926,0,0,0-.109-.062c-.251-.136-1.709-.6-1.936-.76-.267-.41.206-.415.206-.415.091-.023,1.348.6,1.437.6.211.032.293.166.487.206a6.1,6.1,0,0,0,.737.206,11.631,11.631,0,0,0,2.716,1.049c.292.086.58.173.866.271.064.11.345.094.487.188a10.069,10.069,0,0,1,1.806.6c.377-.189.582.252.911.267.551.283,1.32.016,1.776.534.455.66.33,1.57.675,2.293-.3.581.565.818.267,1.4.142.314.3.77.676.864a.608.608,0,0,0,.6-.219c.048-.393-.2-.66-.3-.99.094-.629-.44-1.163-.408-1.776a1.754,1.754,0,0,0-.534-1.24c-.2-.408-.645-.839-.377-1.343-.143-.141-.393.031-.565-.078a3.752,3.752,0,0,0-1.556-.424,6.013,6.013,0,0,0-1.416-.6,9.177,9.177,0,0,0-1.553-.295v-.079c-.487.2-.958-.424-1.476-.533-.315-.283-.942-.016-1.289-.377a1.434,1.434,0,0,1-.957-.233c-.377-.047-.991.044-1.178-.4a3.853,3.853,0,0,0-1.175-.21c-.09-.04-.186-.083-.289-.138a.636.636,0,0,0-.258-.1c-.267.012-.613-.141-.544-.253.036-.054.7-.215.755-.262a.685.685,0,0,0,.264-.092l.021-.009c1.268-.484,2.58-.845,3.786-1.439.925.047,1.743-.361,2.686-.377,1-.722,1.775-1.9,2.9-2.4.472-.376.818-1.429,1.54-1.1.283-.078.44.11.723.047.2-.253.524-.518.454-.842C342.76,329.715,342.237,329.182,342.237,329.182ZM340.856,315a.437.437,0,0,1,.114.274,9.244,9.244,0,0,0,.413,3.356c.345,1.414.644,2.78.942,4.226.127.643-.989.675-.674,1.32.093.6-.268.784-.6,1.209a5.036,5.036,0,0,1,.507.417.721.721,0,0,0,.92.338s.625-.178.553-.717a2.175,2.175,0,0,1,.36-1.3c-.141-.393.127-.8-.188-1.131a5.571,5.571,0,0,0-.534-2.325c.047-.534-.235-.959-.189-1.446a28.641,28.641,0,0,1-.753-3.911l.158-.235c.408-.11.518.455.894.534.19.644.849.911,1.132,1.477a23.04,23.04,0,0,1,2.748,2.937,27.908,27.908,0,0,1,3.1,3.157c.312.313.753.016,1.1.267.517-.283,1.6-.094,1.508-1.021a.577.577,0,0,1,.456-.189c.439.251.958-.016,1.382-.142a22.538,22.538,0,0,0,3.391-.533c.236-.016.314-.236.268-.456a.555.555,0,0,0-.456-.3,12.179,12.179,0,0,1-3.424.644l-.111-.079c.111-.329.6-.109.831-.329a7.754,7.754,0,0,0,2.373-.5c.517-.5,1.256.409,1.586-.487.173-.392,1.3-.329.754-.9-.346-.047-.691-.141-.911.251-.691-.141-1.053.566-1.7.534-.063-.016-.158-.063-.109-.157.814-.472,1.774-.644,2.56-1.194.031-.157-.047-.267-.19-.267a23.891,23.891,0,0,0-3.423,1.351c-.331.2-.629.612-1.069.612-.627.409-1.4.5-1.947,1.083-.345.079-.629-.078-.911.111a2.8,2.8,0,0,1-.832-.785c-1.131-1.241-2.672-2.325-3.85-3.661a16.583,16.583,0,0,1-3.125-2.591l-.675-.566a.715.715,0,0,0-.7.286.3.3,0,0,0-.04.053.513.513,0,0,1-.094.036c-.069-.008-.136,0-.2-.008a1.824,1.824,0,0,1-.22-.046.479.479,0,0,1-.227-.136,1.31,1.31,0,0,1-.527.032s-.483-.193-.339.338A.906.906,0,0,1,340.856,315Zm9.62,7.29c-.235.048-.157-.236-.345-.3-.722-.549-1.334-1.382-2.026-2.01-.347-.268-.582-.722-.989-.943-1.132-.927-2.105-2.2-3.2-3.079a4.642,4.642,0,0,0-.977-1.1.332.332,0,0,1,.142-.345c.172,0,.36.063.344.267.845,1.231,2.042,1.7,3.176,3.252.189-.047.174.11.22.251,1.274,1.257,2.688,2.451,3.958,3.707C350.823,322.192,350.572,322.192,350.477,322.286Z",
    transform: "translate(-298.65 -310.128)"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M248.407,308.266c.56-.139,1.3-.754,1.722-.1.062.031.111-.031.158-.078.173.047.173.236.22.377.095.048.126-.078.188-.11,0-.377.283-.518.534-.785a9.265,9.265,0,0,1,1.382-.534c-.048-.237-.126-.361-.376-.408,0,.077-.1.125-.142.188-.55.015-.691.691-1.241.6l-.048-.3a2.337,2.337,0,0,0,.865-1.32c-.172-.3-.612,0-.865-.047a1.291,1.291,0,0,0-1.241-.408c-.472-.519-.864-1.178-1.617-1.241a1.117,1.117,0,0,1-.424-.864c.172-.408.518.079.8.063,1.429.487,2.591,1.775,4.177,1.932.3.55,1.007.472,1.556.6.378.424.943.2,1.508.267.675.314,1.556.157,2.263.408.188.188.172.707.564.566.142.581.581.958.786,1.477.567.424.314,1.225.378,1.807.157.377-.064.754.267,1.052a1.748,1.748,0,0,1-.942,1.587c-.268.675-1.115.424-1.666.643-.408.393-.88.472-1.24.911a2.839,2.839,0,0,0-.565,1.76,3.1,3.1,0,0,1-.133,1.123,3.9,3.9,0,0,0-.245,1.453c-.189.55,0,1.4-.754,1.571-.124-.078-.408-.141-.344-.377-.378-.174.06-.6-.3-.818l.158-1.131a4.543,4.543,0,0,0,.243-.7,5.969,5.969,0,0,1,1.076-2.819c-.015-.22-.234-.3-.455-.251l-1.476,1.13a3.729,3.729,0,0,0-.677,1.94,2.762,2.762,0,0,1-.673,1.563c-.1.754.36,1.477.029,2.152-.267.08-.6.33-.864.063a4.114,4.114,0,0,1,.346-3.456,1.654,1.654,0,0,0,.223-.322c.4-.741.361-1.743,1.286-2.1,0-.14,0-.3-.157-.345l-.6.345c-.237.126-.55.032-.754.221a6.238,6.238,0,0,0-.979,1.877c-.849,1.085-.513,2.726-.905,4.013l-.379.41a.457.457,0,0,1-.533-.111c-.236-.833.142-1.586.108-2.419a3.138,3.138,0,0,1,.614-1.65,1,1,0,0,1,.006-.243c.1-.644.835-1.021,1.157-1.61l-.109-.22c-.25-.016-.283.268-.407.408a5.1,5.1,0,0,0-1.274,1.422c-.165.25-.321.5-.472.73a5.186,5.186,0,0,0-.894,2.294c-.378.55.109,1.382-.425,1.775a.977.977,0,0,1-.785,0c-.251-.313-.016-.722.03-1.052a16.269,16.269,0,0,0,.19-1.916,11.43,11.43,0,0,1,1.335-1.83,9.2,9.2,0,0,1,.785-.777v-.409c-.236-.079-.455.236-.613.377-.2.271-.419.54-.64.809-1.191,1.448-2.509,2.928-2.218,5.035-.2.266-.533.251-.831.3-.362-.079-.392-.487-.411-.8.3-.88.1-2,.9-2.639-.064-.769.785-1.005,1.052-1.618.21.011.258-.183.358-.275a.173.173,0,0,1,.208-.023c-.032-.346.22-.566.267-.864-.078-.095-.078-.252-.267-.188a6.917,6.917,0,0,0-1.291,1.076,8.625,8.625,0,0,0-2.024,3.825c-.2.519-.172,1.147-.6,1.586a.872.872,0,0,1-.832-.157,6.437,6.437,0,0,1,.753-3.125c.19-.267-.078-.723.22-.943.392-.393.66-.785.99-1.177.346-.321,1.04-.24,1.135-.786-.022-.527-.9-.247-.9-.247-.145.146-.629.1-.629.1a.465.465,0,0,0-.387,0,3.175,3.175,0,0,1-1.3.406,4.439,4.439,0,0,0-.447.521,1.848,1.848,0,0,0-.273,1.516,11.525,11.525,0,0,0-.11,1.963,6.871,6.871,0,0,1,.193,1.625l.025.592.436.218a1.32,1.32,0,0,0-.373.564,6.044,6.044,0,0,0-.469,1.306,2.562,2.562,0,0,0-.565.9c.016.786-.959.8-1.476,1.132-.865-.189-1.634-.252-2.482-.487-.44-.425-1.053-.393-1.588-.6-1.052-.125-1.79-.991-2.669-1.556a14.687,14.687,0,0,1-2.421-1.461c-.285-.18-.642-.217-.927-.386a.251.251,0,0,1-.151.06,1.334,1.334,0,0,0-1.508-.779.806.806,0,0,0-.243.115,6.942,6.942,0,0,1-2.151,1.021c-.173.063-.5.19-.628-.078a8.1,8.1,0,0,1,.816-1.76c1.65-.691,3.331.126,4.712.817a5.279,5.279,0,0,0,1.932,1.132,25.3,25.3,0,0,0,2.97,2.011,3.881,3.881,0,0,1,1.665.486,8.316,8.316,0,0,1,1.587.378c.251-.031.658.125.83-.189.394-.785,1.447-1.085,1.433-2.074.831-1.13-.143-2.34-.049-3.581a1.146,1.146,0,0,0,.156-1.1c.227-.608.292-1.2.488-1.784.06-.186.589-.639.458-.9-.546-.286-.821.876-1.291.718-.44-.2.252-.519-.142-.786l-1.035.966-.143.134-.3.063c-.549.581-1.382.581-1.8,1.366a2.853,2.853,0,0,0-.859.24,2.544,2.544,0,0,1-1.245.339,1.377,1.377,0,0,0-.84.29,2.512,2.512,0,0,1-.905.215,3.689,3.689,0,0,1-2.1.188c-.41-.064-.142-.6-.534-.707a15.075,15.075,0,0,1-.705-2.129,7.33,7.33,0,0,1-.16-1c-.737-.958-.219-2.325-1.053-3.205-.376-.141-.519-.581-.612-.942-.5-.314-.377-.912-.816-1.21-.268-.754-.817-1.273-1.132-2L224.6,309c-.613.33-.33,1.162-.455,1.775-.3.314-.047.77-.064,1.162-.094,1.257-.408,2.419-.613,3.613-.269.556-.041,1.324-.329,1.877a.988.988,0,0,1-.267.322.528.528,0,0,1-.645-.188c.006-.045.013-.089.018-.134a23.973,23.973,0,0,0,.282-3.417c.362-.424.219-1.052.423-1.539.078-.487.33-1.084.064-1.508-.456.282-.534.927-.629,1.46a8.062,8.062,0,0,1-.91,2.561c-.126.3-.221.722-.6.754-.612-.236.079-.88.062-1.351.629-.487.346-1.383.423-2.043.142-.817.88-1.3,1.085-2.1-.3-.315-.645.11-1.007.078-.627,1.241-1.947.613-2.826,1.272-.376.534-1.032.526-1.366.644-.279-.272-.279-.486,0-.943a1.15,1.15,0,0,0,1.051-.267,6.669,6.669,0,0,0,2.042-1.132c.535-.439,1.227-.487,1.776-.894.143-.032.471.094.519-.189-.629-.77.613-.346.753-.864.236-.723,1.053-.534,1.554-.832.221-.063.567-.173.755.031.707.251.848,1.005.974,1.618-.064.173-.126.5-.408.424-.189-.362-.376-.738-.566-1.1-.171.063-.394-.031-.486.189-.127.44.393.314.519.643.014.629.645.755,1.051,1.053l.534,1.021c.409.926.928,1.853,1.24,2.8a15.2,15.2,0,0,1,1.51,4.4c-.112.613.5,1.006.864,1.367a2.5,2.5,0,0,0,2.041-.613,19.376,19.376,0,0,0,2.106-.6,18.738,18.738,0,0,0,2.01-1.508,5.221,5.221,0,0,0,.089-1.185c-.155-.885-.687-.182-.922-.669-.361-.425.518-.487.219-.943-.58-.911-1.776-.691-2.591-1.195a8.4,8.4,0,0,1-1.256-1.853c-.314-.315-.787-.267-1.195-.346-.581-.22-.848-.957-1.508-.943-.739-.864-1.744-1.052-2.5-1.885-.189-.094-.645-.063-.519-.44-.581-.5-1.352-.958-1.932-1.508-.284-.109-.519.016-.754-.188-.078-.628-.865-.5-1.32-.722-.5-.8-1.649-.456-1.916-1.4-1.083.016-1.9-.66-2.875-.943a2.232,2.232,0,0,1-.988-.629.8.8,0,0,1,.246-.644c.706.425,1.355.63,2.062,1.007a4.865,4.865,0,0,1,1.288.377c1.226.141,2.026,1.3,3.125,1.744.66-.2.912.519,1.432.754.407.11.706.644,1.13.786.487.455,1.148.628,1.666,1.052.471.5.878,1.43,1.7,1.319.627.2.816.863,1.318,1.209.612-.189,1.037.3,1.509.566.069.287.342.468.591.657.31.235.582.482.383.962.313.33.172-.424.564-.378.094.048.078.142.078.236h.614a5.97,5.97,0,0,1,1.132,1.352c.218.282.486-.236.674.157.614.047.848.738,1.461.785a2.766,2.766,0,0,1,1.666.266c.423.031.409.5.6.754a3.329,3.329,0,0,1,1.856-.3.532.532,0,0,1,.289.227,3.439,3.439,0,0,0,1.3.265,10.688,10.688,0,0,0,1.258,0,5.6,5.6,0,0,1,1.208-.05c.874-.1,1.14.144,1.221.291a1.174,1.174,0,0,1,.266.242c.189-.188.189-.613.565-.566.016.047.094.063.078.11.1.048.158-.047.22-.11.566-.015.786-.612,1.318-.706.237-.079.409-.472.676-.346.52-.455,1.162-.062,1.776-.188,1.021-.3,2.168-.251,2.984-1.052.283-.11.676.063.864-.267a3.937,3.937,0,0,0,1.274-.487c.58-.3.44-1,.565-1.555h.046v-.44c-.345-.455-.078-1.194-.533-1.555-.771.048-.738-1.1-1.54-.974-.534.063-1.084-.156-1.618-.078-.958.675-2.449,1.021-2.719,2.372-.25.173-.611.377-.423.754a.505.505,0,0,1-.488.236c-.393-.189-.219-.708-.266-1.022a1.416,1.416,0,0,0,.157-.833l-.221.032c-.3.315-.627.094-.832-.189-.551.346-.929.849-1.508.99a3.171,3.171,0,0,1-1.241-.612c-.3.126-.629-.221-.88,0a7.365,7.365,0,0,1-.864-1.273l.048-.047c-.11-.016-.33-.141-.236-.3.048.012.115-.013.158.011a2.941,2.941,0,0,1-.723-2.007c-.425-.612-.393-1.4-.754-2.041a9.419,9.419,0,0,1-1.588-3.268c.143-.267.348-.628.724-.534.613.455,1.4.471,2.043.864.062.141.3.425,0,.534-.409-.173-.99.205-1.289-.345a.463.463,0,0,0-.408.188.66.66,0,0,0,.408.534c.174.644.706,1.179.865,1.806.408.2.124.754.533.974-.141.361.236.612.111,1.02.378.236.315.723.6,1.022a4.072,4.072,0,0,0,1.744,2.372,1.83,1.83,0,0,0,.485-.191c-.011-.008-.026-.017-.037-.026A2.2,2.2,0,0,1,248.407,308.266Z",
    transform: "translate(-217.042 -299.67)"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M325.757,319.171a1.013,1.013,0,0,0-.117-.083c.017-.094-.03-.22.034-.3.374-.613.69.2,1.178.109a1.562,1.562,0,0,0-.912-1.4c-.064-.376-.628-.456-.722-.864-.361.016-.44-.566-.818-.487-.2.11-.516.2-.564.456a18.708,18.708,0,0,0,1.356,2.855S326.076,319.913,325.757,319.171Z",
    transform: "translate(-295.68 -311.8)"
  })), /*#__PURE__*/React__default.createElement("g", {
    transform: "translate(0 48.034)"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M283.526,481.863v4.8l2.9-4.8Z",
    transform: "translate(-241.48 -481.863)"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M350.768,493.211l3.421-.009a22.6,22.6,0,0,0,2.464-.048c.3-.075.465-.3.545-.275s.045.141.045.141c0,.525,0,.356,0,1.033,0,.746.041.455.041,1.007,0,0,.037.115-.044.137s-.007-.09-.444-.24a15.438,15.438,0,0,0-2.6-.1h-3.424l.006,5.376,4.861,0a6.363,6.363,0,0,0,1.794-.225c.293-.111.549-.388.629-.365s.046.141.046.141c-.04.548-.1,1.047-.187,1.7l-.044.492h-8.14c-.75,0-.8.064-1.347.064,0,0-.116.035-.14-.046s.043-.025.24-.442a5.622,5.622,0,0,0,.222-1.981c0-1.275,0-3.449-.01-5.54s.011-3.714.01-4.988a5.649,5.649,0,0,0-.222-1.984c-.2-.415-.263-.361-.24-.441s.14-.045.14-.045c.551,0,.6.062,1.347.062h5.015c1.407,0,2.09.011,2.925,0l-.009.492c0,.66,0,.987,0,1.524,0,0,.037.118-.042.141s-.239-.18-.532-.29a6.341,6.341,0,0,0-1.786-.225h-4.535Z",
    transform: "translate(-289.134 -485.329)"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M131.795,485.6s3.832,8.885,5.543,12.76a16.726,16.726,0,0,0,1.157,2.219c.359.424.414.413.414.413s-1.339-.039-2.012-.039-1.063.088-1.05.039a1.621,1.621,0,0,0-.088-1.286c-.042-.1-.337-.8-.471-1.127-1.166-2.7-3.76-8.73-3.76-8.73-.17-.427-.028-.427-.232,0,0,0-2.591,6.034-3.758,8.73-.135.326-.43,1.023-.471,1.127a1.625,1.625,0,0,0-.089,1.286c.014.049-.249-.039-.923-.039s-2.011.039-2.011.039.054.011.412-.413a16.758,16.758,0,0,0,1.155-2.219c1.712-3.875,5.544-12.76,5.544-12.76C131.349,485.141,131.565,485.109,131.795,485.6Z",
    transform: "translate(-124.042 -484.352)"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M301.467,488.572c0,1.275,0,8.4-.006,11.123a5.593,5.593,0,0,1-.217,1.973c-.2.417-.263.362-.24.442s.141.046.141.046c.55,0,.66-.064,1.408-.064.675,0,.8.05,1.325.05,0,0,.118.038.141-.043s-.178-.238-.29-.531a7.535,7.535,0,0,1-.185-1.891c-.007-2.807,0-10.285,0-11.1h2.231a10.367,10.367,0,0,1,2.213.2c.293.112.448.313.529.291s.046-.141.046-.141c0-.525.007-1.432,0-2.105H296.03c0,.674-.166,1.665-.166,2.189,0,0-.036.116.045.139s.237-.177.529-.289a11.57,11.57,0,0,1,2.339-.245l2.69-.045",
    transform: "translate(-250.559 -485.515)"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M438.867,494.56l0,4.256a11.4,11.4,0,0,1-.249,2.8c-.195.417-.264.36-.24.442s.14.045.14.045c.55,0,.673-.063,1.421-.063.674.007.874.05,1.4.05,0,0,.117.036.142-.043s-.18-.238-.29-.53a7.112,7.112,0,0,1-.186-1.853l.009-5.1s4.675-7.306,5.007-7.359a1.031,1.031,0,0,0,.742-.429s-1.316,0-1.991,0-1.4-.087-1.383-.037a1.446,1.446,0,0,1-.207,1.228c-.276.475-2.919,4.621-3.093,4.794-.177-.173-2.9-4.259-3.17-4.733a1.471,1.471,0,0,1-.187-1.249c.012-.049-.924.038-1.6.038s-2.013-.038-2.013-.038.158.02.574.388S438.867,494.56,438.867,494.56Z",
    transform: "translate(-351.633 -485.437)"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M485.745,494.326s4.733,7.018,5.158,7.4.576.385.576.385-1.336-.037-2.013-.037-1.636.086-1.624.037a1.463,1.463,0,0,0-.187-1.249c-.275-.475-2.929-4.507-3.1-4.681-.177.175-2.811,4.206-3.086,4.681a1.468,1.468,0,0,0-.189,1.249c.014.049-.755-.037-1.43-.037s-2.013.037-2.013.037.16-.019.576-.385,5.1-7.288,5.1-7.288-4.5-6.93-5.1-7.255c-.488-.263-.427-.388-.427-.388s1.189.036,1.864.036,1.61-.086,1.6-.036a1.473,1.473,0,0,0,.189,1.25c.274.474,2.889,4.423,3.063,4.6.178-.173,2.724-4.059,3-4.534a1.639,1.639,0,0,0,.228-1.311c-.012-.05.866.036,1.54.036s1.845-.036,1.845-.036a4.126,4.126,0,0,0-.7.512C490.187,487.677,485.745,494.326,485.745,494.326Z",
    transform: "translate(-384.561 -485.48)"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M398.577,495.027s3.85,5.456,4.152,5.911a2.879,2.879,0,0,0,2.4,1.327,8.86,8.86,0,0,0,1.22-.077s-.094-.012-.5-.386c-.781-.722-4.655-6.256-4.655-6.256,1.648-.709,3.52-1.826,3.435-4.394-.12-3.7-2.646-4.643-6.519-4.534-.471.013-1.522.023-2.1.02-.747,0-.995-.062-1.545-.062,0,0-.117-.034-.14.045s.178.243.178.243c.323.437.323,2.51.323,3.19,0,1.483.015,8.406.015,9.474a5.6,5.6,0,0,1-.226,1.978c-.195.417-.264.36-.24.442s.141.045.141.045c.55,0,.748-.063,1.5-.063.675.007.751.05,1.276.05,0,0,.117.036.14-.043s-.179-.238-.291-.53a7.515,7.515,0,0,1-.183-1.89s.013-10.1.013-11.106c0-.705.35-.764,1.23-.774,2.965-.036,4.278,1.516,4.294,3.671C402.512,493.712,401.21,494.844,398.577,495.027Z",
    transform: "translate(-323.069 -485.329)"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M185.368,495.027s3.85,5.456,4.152,5.911a2.872,2.872,0,0,0,2.4,1.327,8.857,8.857,0,0,0,1.22-.077s-.093-.012-.5-.386c-.78-.722-4.655-6.256-4.655-6.256,1.648-.709,3.518-1.826,3.435-4.394-.121-3.7-2.647-4.643-6.52-4.534-.47.013-1.522.023-2.1.02-.747,0-1-.062-1.546-.062,0,0-.117-.034-.141.045s.178.243.178.243c.324.437.325,2.51.325,3.19,0,1.483.015,8.406.013,9.474a5.626,5.626,0,0,1-.225,1.978c-.2.417-.265.36-.24.442s.14.045.14.045c.55,0,.748-.063,1.5-.063.674.007.749.05,1.274.05,0,0,.118.036.142-.043s-.18-.238-.292-.53a7.572,7.572,0,0,1-.182-1.89s.011-10.1.011-11.106c0-.705.352-.764,1.23-.774,2.964-.036,4.278,1.516,4.294,3.671C189.3,493.712,188,494.844,185.368,495.027Z",
    transform: "translate(-166.069 -485.329)"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M240.5,498.266c-1.337,1.663-3.612,2.19-5.616,2.187-3.672,0-6.245-3.289-6.288-6.608-.051-4.158,2.626-6.685,6.563-6.685,1.454,0,3.938.934,4.855,2.439a2.2,2.2,0,0,1,.264.742l.147.011s-.007-.157-.017-.252c-.038-.608-.253-1.376-.342-2.063a5.855,5.855,0,0,1,.009-1.448,2.646,2.646,0,0,1-.508-.016,23.089,23.089,0,0,0-4.309-.666c-5.214-.069-8.636,2.855-8.75,7.938-.105,4.725,3.371,7.962,8.626,7.962a23.994,23.994,0,0,0,4.759-.564s.292-.771.517-1.363a14.376,14.376,0,0,0,.452-1.383Z",
    transform: "translate(-199.495 -484.84)"
  })))));
};

const ArcteryxLogoNoText = _ref => {
  let {
    fill,
    width,
    height,
    title
  } = _ref;
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: fill,
    width: width,
    height: height,
    viewBox: "0 0 75 50"
  }, /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("g", {
    id: "bird",
    stroke: "null"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "m7.27794,32.26484c0.19412,-0.11 0.38823,-0.22969 0.58235,-0.32353c0.71499,-0.23294 1.02234,-1.09998 1.85056,-1.02234c0.75058,-0.84763 1.86997,-1.04175 2.73701,-1.71468a0.98999,0.98999 0 0 1 0.28146,-0.44323c0.54999,-0.41412 -0.36881,-0.74086 -0.36881,-0.74086c-0.26853,-0.35587 -0.67293,-0.02912 -0.67293,-0.02912a4.72345,4.72345 0 0 1 -0.62763,0.32353c-0.11646,0.4044 -0.54028,0.44323 -0.84763,0.61794a7.98457,7.98457 0 0 1 -1.56262,1.06116c-0.38823,0.58235 -1.07411,0.69234 -1.52379,1.13233a2.16761,2.16761 0 0 0 -0.72469,0.8088s-1.07086,0.97057 0.35264,0.44646l0.52411,-0.11646l-0.00001,-0.00001l-0.00002,0.00001z",
    id: "right-leg",
    stroke: "null"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "m5.95149,33.85658a0.67616,0.67616 0 0 1 -0.07764,0.10677a0.10029,0.10029 0 0 1 -0.05177,0.03882a6.59019,6.59019 0 0 0 -1.61762,1.90232c-0.48205,0.7344 -0.97057,1.4688 -1.80203,1.98968c-0.61794,0 -0.97057,0.64705 -1.48498,0.88645c-0.1553,-0.03882 -0.19088,-0.21352 -0.26853,-0.32353a1.91526,1.91526 0 0 1 -0.18764,-1.21644a1.75351,1.75351 0 0 0 0.88322,-0.45293c0.32353,-0.2847 0.66646,-0.58235 0.99645,-0.89292c1.01586,-0.95116 2.00909,-1.97997 3.01525,-2.86966c0,0.0097 0.77323,-0.35912 0.59529,0.83145l0,-0.00002l-0.00001,0.00001l0.00001,0z",
    id: "right-toe",
    stroke: "null"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "m5.73797,31.6081c-1.15498,0.46264 -2.5235,0.46264 -3.42935,1.38792c-0.42381,0.23294 -1.15822,-0.17471 -1.42674,0.36558c0.07764,0.13588 0.01941,0.3494 0.03882,0.50146l-0.42381,-0.03882l0.09705,0.82822c1.02234,0.13588 1.55938,-1.17439 2.5429,-1.2941l0.13588,0.13588l0,0.28794c-0.1553,0.09705 -0.36558,-0.1553 -0.54028,0a5.38021,5.38021 0 0 1 -1.81173,1.23263c-0.1553,0.09382 -0.16176,0.4044 -0.32353,0.4303l-0.13912,1.14851c0.57263,0.13912 0.97057,-0.32353 1.40087,-0.69881a3.23525,3.23525 0 0 1 0.32353,-0.26528c1.02234,-1.11939 2.35202,-1.98643 3.14142,-3.19966c-0.00647,0.0097 0.28146,0.19412 0.41412,-0.82176l-0.00001,0.00001l-0.00001,0l-0.00001,-0.00002z",
    id: "right-foot",
    stroke: "null"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "m29.86963,31.3978c0.09705,1.49792 -0.58881,2.6529 -1.61762,3.77553c-1.04175,0.27176 -2.06086,1.04175 -3.14142,0.4044c-0.67616,-0.36558 -1.48498,0.03882 -1.9832,-0.73117c-0.23294,-0.07764 -0.5597,-0.01941 -0.64705,-0.32353c0.13264,-0.32353 0.56617,-0.32353 0.81529,-0.56294c1.23263,0.1553 2.79526,1.1388 3.88229,0.03882c0.46589,-0.21352 1.15822,-0.27176 1.21322,-0.92529a1.34262,1.34262 0 0 1 0.46589,-1.11939c0.37853,0 0.4303,-0.47558 0.54999,-0.8088c0,0 -0.03559,-1.17116 0.41087,-0.98999c0,0 0.40764,0.43353 0,0.71175l0.05177,0.53058l-0.00002,0l-0.00001,0.00001l0,0.00002z",
    id: "right-knee",
    stroke: "null"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "m20.72684,25.45142c-0.37853,0.35587 -0.7894,0.68263 -0.97057,0.87675c-1.53997,0.54028 -3.27406,0.86704 -4.85287,0.19412c-0.2103,-0.36558 0.39794,-0.52411 0.02912,-0.87029c0.13588,-0.13588 0.20382,-0.275 0.41734,-0.19735c0.2103,0.57911 0.86381,0.29441 1.2941,0.37205c0.64705,0.22969 1.17763,-0.22969 1.75351,-0.13588c0.4044,-0.19412 0.61794,-0.19412 1.02234,-0.38499a0.42705,0.42705 0 0 0 0.23294,-0.04528s1.34262,-0.86057 1.07411,0.19088l0.00001,-0.00001l-0.00002,0l-0.00001,0z",
    id: "left-knee",
    stroke: "null"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "m53.59043,23.41646c-0.71175,-0.64705 -1.31028,0.25882 -1.31028,0.25882a1.43646,1.43646 0 0 0 -0.50793,0.6244c-0.97057,0.46264 -1.38792,1.73409 -2.37144,2.12232c-0.59529,0.59853 -1.32969,0.97057 -1.9832,1.65645c-1.2941,0.38499 -2.93113,0.50146 -4.20582,1.15822c-0.97057,0.38499 -2.04468,0.5597 -3.00554,0.92529c-1.17763,0.7894 -2.54613,1.06116 -3.70111,1.85056c-0.19412,0.17471 -0.64705,0.26853 -0.52087,0.64705c0.17146,0.27176 0.52087,0.05824 0.75058,0.19412s0.75381,0.09705 0.73117,0.50146c-0.24911,0.23294 -0.7894,0.21352 -0.73117,0.69558a8.83544,8.83544 0 0 0 1.46557,0.73117a10.35277,10.35277 0 0 0 2.0382,1.11293c1.20675,0.51117 2.47819,0.88322 3.66876,1.42998c0.94469,0.28794 2.02527,0.34618 2.85348,0.84763c1.11939,0.32353 2.33261,0.67293 3.52642,0.92529c0.7344,0.28794 0.04206,0.92529 0.17471,1.46557c-0.01941,0.36558 -0.32353,0.64705 -0.17471,1.02234c-0.57587,0.88645 -0.6147,1.94115 -0.51764,2.96672c-0.28794,0.11646 -0.1553,0.42381 -0.07764,0.59853a5.75872,5.75872 0 0 0 -0.46589,1.81173c-0.13264,-0.03882 -0.2103,0.09705 -0.22969,0.17471c-0.09705,0.88645 -0.19088,1.57879 -0.28794,2.44908a2.11908,2.11908 0 0 0 1.75351,-0.13588c-0.32353,-0.64705 0.19088,-1.21322 0.15205,-1.88938c0.2103,-0.4044 0.05824,-0.7894 0.17471,-1.25203c0.52087,-1.61762 0.53704,-3.33554 0.69234,-5.05022c-0.07764,-0.27176 -0.28794,-0.48205 0.09705,-0.69234l0.19088,0.19412c-0.15205,0.59853 0.09705,1.25203 -0.05824,1.81173c0.38823,1.17439 0.04206,2.48791 0.23294,3.73994c0.8088,0.44323 -0.25235,1.31028 0.5597,1.75351a0.92529,0.92529 0 0 0 0.30087,0.74734c0.32353,0.07441 0.75381,-0.07764 1.22292,-0.55645c0.11646,-1.1388 -0.54028,-1.94115 -0.5597,-3.00554c-0.25235,-0.7344 -0.11646,-1.42674 -0.54028,-2.08349c-0.01941,-0.64705 -0.26853,-1.27144 -0.32353,-1.90879c-0.32353,-0.27176 -0.17471,-0.82822 -0.13588,-1.1938c-0.11646,-0.67616 -0.07441,-1.63703 -0.92529,-1.94115c-1.44615,-0.1553 -2.81466,-0.73117 -4.222,-1.09674c-0.84763,-0.17471 -1.67585,-0.64705 -2.58819,-0.7894a8.3631,8.3631 0 0 0 -0.97057,-0.32353a10.87688,10.87688 0 0 1 -2.34231,-0.82498c-0.19735,-0.055 -0.39146,-0.11646 -0.58558,-0.18117a1.15498,1.15498 0 0 0 -0.13264,-0.07441c-0.32353,-0.16823 -2.09645,-0.73764 -2.37467,-0.93175c-0.32353,-0.5047 0.25235,-0.50793 0.25235,-0.50793c0.11323,-0.02912 1.65321,0.73117 1.7632,0.73117c0.25882,0.03882 0.35912,0.20382 0.59853,0.25235a7.4734,7.4734 0 0 0 0.90588,0.25235c1.03204,0.61794 2.18379,0.94469 3.3323,1.2941c0.35912,0.10677 0.71175,0.21352 1.06439,0.32353c0.07764,0.13588 0.42381,0.11646 0.59853,0.22969c0.71175,0.32353 1.56262,0.28794 2.21614,0.73117c0.46264,-0.23294 0.71499,0.32353 1.11939,0.32353c0.67616,0.34618 1.61762,0.01941 2.17732,0.64705c0.5597,0.8088 0.4044,1.94115 0.82822,2.81466c-0.36558,0.71499 0.69234,1.00293 0.32353,1.71468c0.17471,0.38499 0.36558,0.94469 0.82822,1.06116a0.74734,0.74734 0 0 0 0.73117,-0.26853c0.05824,-0.48205 -0.25235,-0.8088 -0.36558,-1.21322c0.11646,-0.76999 -0.54028,-1.42674 -0.50146,-2.18056c-0.07764,-0.50146 -0.1553,-1.15498 -0.64705,-1.52379c-0.25235,-0.50146 -0.79263,-1.0288 -0.46264,-1.64674c-0.17471,-0.17146 -0.48205,0.03882 -0.69234,-0.09382c-0.5597,-0.38823 -1.25203,-0.4044 -1.90879,-0.52087a7.37635,7.37635 0 0 0 -1.73733,-0.73764a11.32334,11.32334 0 0 0 -1.90556,-0.36235l0,-0.09705c-0.59853,0.25235 -1.17439,-0.52087 -1.81173,-0.64705c-0.38823,-0.34618 -1.15498,-0.01941 -1.58203,-0.46264a1.75997,1.75997 0 0 1 -1.17439,-0.2847c-0.46264,-0.05824 -1.21644,0.055 -1.44615,-0.48528a4.72669,4.72669 0 0 0 -1.44292,-0.25882c-0.11,-0.04853 -0.22969,-0.10029 -0.35587,-0.16823a0.7797,0.7797 0 0 0 -0.32353,-0.12618c-0.32353,0 -0.75058,-0.17146 -0.66646,-0.32353c0.04528,-0.06794 0.85411,-0.26528 0.92851,-0.32353a0.84117,0.84117 0 0 0 0.32353,-0.11323l0.02587,0c1.55615,-0.59529 3.16731,-1.03528 4.64581,-1.76644c1.13557,0.05824 2.1385,-0.44323 3.29671,-0.46264c1.23263,-0.88645 2.17732,-2.33261 3.55877,-2.95053c0.57911,-0.46264 1.00293,-1.75351 1.88938,-1.3491c0.34618,-0.09705 0.54028,0.13588 0.88645,0.05824c0.24589,-0.32353 0.64705,-0.64705 0.55645,-1.03528c0.08087,-0.35587 -0.56294,-1.0094 -0.56294,-1.0094l0.00002,-0.00006l-0.00001,-0.00005l0,-0.00003zm-1.69527,-17.40884a0.53382,0.53382 0 0 1 0.13912,0.32353c-0.02912,1.31997 0.03235,2.88259 0.5047,4.11847c0.42381,1.73409 0.7894,3.41317 1.15498,5.1764c0.1553,0.7894 -1.21322,0.82822 -0.82822,1.61762c0.11323,0.73117 -0.32353,0.97057 -0.7344,1.48498a6.14696,6.14696 0 0 1 0.62116,0.51117a0.88322,0.88322 0 0 0 1.12911,0.41412s0.76675,-0.21676 0.6794,-0.87998c0.06146,-0.57263 0.07764,-1.22292 0.43999,-1.58851c-0.17146,-0.48205 0.1553,-0.97057 -0.22969,-1.38792c0.11646,-1.04175 -0.36558,-1.94115 -0.64705,-2.85348c0.05824,-0.64705 -0.28794,-1.17763 -0.23294,-1.77292a35.13474,35.13474 0 0 1 -0.92529,-4.79787l0.19412,-0.28794c0.50146,-0.13588 0.64705,0.5597 1.09674,0.64705c0.23294,0.7894 1.04175,1.11616 1.38792,1.81173a28.23396,28.23396 0 0 1 3.37436,3.63642c1.36852,1.2941 2.70143,2.44908 3.80141,3.88229c0.38177,0.38499 0.92529,0.01941 1.3491,0.32353c0.64705,-0.34618 1.96702,-0.11646 1.85056,-1.25203a0.70852,0.70852 0 0 1 0.5597,-0.23294c0.54028,0.32353 1.17439,-0.01941 1.69527,-0.17471a27.67103,27.67103 0 0 0 4.16052,-0.64705c0.28794,-0.01941 0.38499,-0.28794 0.32353,-0.5597a0.6794,0.6794 0 0 0 -0.5597,-0.36558c-1.36852,0.32353 -2.77585,0.86704 -4.20582,0.7894l-0.13588,-0.09705c0.13588,-0.4044 0.73117,-0.13264 1.0191,-0.4044a9.51161,9.51161 0 0 0 2.91172,-0.61794c0.64705,-0.61794 1.53997,0.50146 1.94115,-0.59853c0.21352,-0.48205 1.60144,-0.4044 0.92529,-1.09998c-0.42381,-0.05824 -0.84763,-0.17146 -1.11616,0.32353c-0.84763,-0.17471 -1.2941,0.69234 -2.08027,0.64705c-0.07764,-0.01941 -0.19412,-0.07764 -0.13588,-0.19412c0.99969,-0.57911 2.17732,-0.7894 3.14142,-1.46557c0.03882,-0.19412 -0.05824,-0.32353 -0.23294,-0.32353c-1.48174,0.34618 -2.81143,1.09674 -4.20582,1.65645c-0.4044,0.25235 -0.77323,0.75058 -1.31351,0.75058c-0.76999,0.50146 -1.71468,0.61794 -2.38761,1.32969c-0.42381,0.09705 -0.77323,-0.09382 -1.11616,0.13588a3.43583,3.43583 0 0 1 -1.02234,-0.97057c-1.38792,-1.52379 -3.2773,-2.85348 -4.72345,-4.49375c-1.36852,-0.94469 -2.75643,-1.94115 -3.83376,-3.18025l-0.82822,-0.69558a0.87675,0.87675 0 0 0 -0.86381,0.3494a0.35587,0.35587 0 0 0 -0.04853,0.06471a0.60822,0.60822 0 0 1 -0.11646,0.04528c-0.08412,0 -0.16823,0 -0.24911,0a2.21937,2.21937 0 0 1 -0.26853,-0.055a0.58881,0.58881 0 0 1 -0.27823,-0.16823a1.61762,1.61762 0 0 1 -0.64705,0.03882s-0.59204,-0.23617 -0.41412,0.41412a1.1097,1.1097 0 0 1 -0.01618,0.67293l-0.00324,0l0.00001,-0.00002l-0.00004,0l0.00003,0zm11.80541,8.94545c-0.28794,0.05824 -0.19088,-0.28794 -0.42381,-0.36558c-0.88645,-0.67293 -1.63703,-1.69527 -2.48467,-2.46526c-0.42381,-0.32353 -0.71499,-0.88645 -1.21322,-1.15822c-1.38792,-1.1388 -2.58819,-2.69818 -3.93406,-3.77876a5.69403,5.69403 0 0 0 -1.18733,-1.3491a0.40764,0.40764 0 0 1 0.17471,-0.42381c0.2103,0 0.44323,0.07764 0.42381,0.32353c1.03852,1.51085 2.50408,2.08996 3.88229,3.98905c0.23294,-0.05824 0.21352,0.13588 0.26853,0.32353c1.56262,1.54321 3.29671,3.00554 4.85287,4.54874c0.06794,0.24264 -0.23941,0.24264 -0.35587,0.35587l-0.00324,0l0,0.00001l-0.00001,0z",
    id: "front-legs",
    stroke: "null"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "m38.6048,10.58549c0.68588,-0.17146 1.59174,-0.92529 2.11261,-0.11971c0.07764,0.03882 0.13588,-0.03882 0.19412,-0.09705c0.21352,0.05824 0.21352,0.29117 0.27176,0.46264c0.11646,0.05824 0.1553,-0.09705 0.23294,-0.13588c0,-0.46264 0.34618,-0.64705 0.64705,-0.97057a11.36864,11.36864 0 0 1 1.69527,-0.64705c-0.05824,-0.29117 -0.1553,-0.44323 -0.46264,-0.50146c0,0.09382 -0.11646,0.15205 -0.17471,0.22969c-0.67293,0.01941 -0.84763,0.84763 -1.52379,0.73117l-0.05824,-0.36558c0.57911,-0.36558 0.86704,-1.02234 1.06116,-1.61762c-0.2103,-0.36558 -0.75058,0 -1.06116,-0.05824c-0.32353,-0.48205 -0.92204,-0.54028 -1.52379,-0.50146c-0.57911,-0.64705 -1.06116,-1.44615 -1.9832,-1.52379c-0.28794,-0.32353 -0.5597,-0.61794 -0.52087,-1.06116c0.2103,-0.50146 0.64705,0.09705 0.97057,0.07764c1.75351,0.59853 3.18025,2.17732 5.12463,2.37144c0.36881,0.67616 1.23585,0.57911 1.90879,0.7344c0.46264,0.52087 1.15822,0.24911 1.85056,0.32353c0.82822,0.38499 1.90879,0.19412 2.77585,0.50146c0.22969,0.22969 0.2103,0.86704 0.69234,0.69234c0.17471,0.71175 0.71175,1.17439 0.97057,1.81173c0.69558,0.52087 0.38499,1.50439 0.46264,2.21614c0.19088,0.46264 -0.07764,0.92529 0.32353,1.2941a2.14497,2.14497 0 0 1 -1.15498,1.94115c-0.32353,0.82822 -1.36852,0.52087 -2.04468,0.7894c-0.50146,0.48205 -1.08057,0.57911 -1.52379,1.11939c-0.36558,0.64705 -0.8088,1.3491 -0.69234,2.15791a3.80464,3.80464 0 0 1 -0.16176,1.37821a4.78492,4.78492 0 0 0 -0.30087,1.78261c-0.23294,0.67616 0,1.71468 -0.92529,1.94115c-0.15205,-0.09705 -0.50146,-0.17471 -0.42381,-0.46264c-0.46264,-0.21352 0.07441,-0.7344 -0.36881,-1.00293l0.19412,-1.38792a5.53549,5.53549 0 0 0 0.29763,-0.85735c0.32353,-1.20351 0.40764,-2.50085 1.31997,-3.45848c-0.01618,-0.26853 -0.28794,-0.36558 -0.55645,-0.32353l-1.80203,1.39762c-0.59204,0.66322 -0.67616,1.53675 -0.83145,2.38114c-0.12618,0.70205 -0.29441,1.38469 -0.82498,1.9185c-0.11646,0.92529 0.44323,1.81173 0.03559,2.63996c-0.32353,0.09705 -0.73117,0.4044 -1.06116,0.07764c-0.69234,-1.3491 -0.13264,-3.00554 0.42381,-4.24141a2.02527,2.02527 0 0 0 0.27176,-0.39471c0.49176,-0.90911 0.44323,-2.1385 1.57879,-2.58819c0,-0.17146 0,-0.36558 -0.19412,-0.42381l-0.73117,0.42381c-0.29117,0.1553 -0.67293,0.03882 -0.92529,0.27176c-0.44971,0.75058 -1.0288,1.44939 -1.20026,2.3035c-1.04175,1.32969 -0.63087,3.34524 -1.1097,4.92404l-0.46589,0.50146a0.5597,0.5597 0 0 1 -0.64705,-0.13588c-0.28794,-1.02234 0.17471,-1.94115 0.13264,-2.96995c0.13588,-0.71175 0.23294,-1.46557 0.75381,-2.02527a1.24234,1.24234 0 0 1 0,-0.29763c0.11971,-0.7894 1.02558,-1.25203 1.42026,-1.97674l-0.13588,-0.26853c-0.32353,-0.01941 -0.34618,0.32353 -0.49823,0.50146a6.2602,6.2602 0 0 0 -1.56262,1.74379c-0.20382,0.30735 -0.39471,0.61146 -0.57911,0.89616c-0.71175,0.7894 -0.82822,1.83114 -1.09674,2.81466c-0.46264,0.67616 0.13588,1.69527 -0.52087,2.17732a1.19704,1.19704 0 0 1 -0.97057,0c-0.32353,-0.38499 -0.01941,-0.88645 0.03559,-1.2941c0.19412,-0.71499 0.13588,-1.65645 0.23294,-2.35202a14.00213,14.00213 0 0 1 1.65645,-2.22585a11.26188,11.26188 0 0 1 0.97057,-0.9544l0,-0.50146c-0.28794,-0.09705 -0.55645,0.28794 -0.75381,0.46264c-0.24589,0.32353 -0.51441,0.64705 -0.78617,0.99322c-1.46233,1.77615 -3.07995,3.59436 -2.72084,6.17932c-0.24911,0.32353 -0.64705,0.32353 -1.0191,0.36558c-0.44323,-0.09705 -0.48205,-0.59853 -0.5047,-0.97057c0.36558,-1.08057 0.11971,-2.44908 1.09998,-3.23525c-0.07764,-0.94469 0.97057,-1.23263 1.2941,-1.98643c0.25882,0 0.32353,-0.22323 0.43999,-0.32353a0.21352,0.21352 0 0 1 0.25558,-0.02912c-0.03882,-0.42381 0.26853,-0.69558 0.32353,-1.06116c-0.09705,-0.11646 -0.09705,-0.32353 -0.32353,-0.22969a8.47633,8.47633 0 0 0 -1.58528,1.31997a10.58248,10.58248 0 0 0 -2.51378,4.66199c-0.25235,0.64705 -0.2103,1.40733 -0.73117,1.94115a1.07086,1.07086 0 0 1 -1.02234,-0.19412c-0.21352,-1.44615 0.50146,-2.58819 0.92529,-3.83376c0.23294,-0.32353 -0.09705,-0.88645 0.26853,-1.15822c0.48205,-0.48205 0.8088,-0.97057 1.21644,-1.44615c0.42381,-0.39471 1.27792,-0.29441 1.39439,-0.97057c-0.02912,-0.64705 -1.09998,-0.30412 -1.09998,-0.30412c-0.17795,0.17795 -0.77323,0.11971 -0.77323,0.11971a0.56941,0.56941 0 0 0 -0.47558,0c-0.26528,0.26528 -1.15498,0.4303 -1.59174,0.49823a5.40932,5.40932 0 0 0 -0.54999,0.64705c-0.32353,0.54028 -0.56617,1.22292 -0.32353,1.86027a14.14124,14.14124 0 0 0 -0.13588,2.41026a8.43752,8.43752 0 0 1 0.23617,1.99291l0.02912,0.72469l0.53382,0.26528a1.61762,1.61762 0 0 0 -0.4594,0.69234c-0.32353,0.46589 -0.36881,1.07086 -0.57587,1.61762a3.14142,3.14142 0 0 0 -0.69234,1.09674c0.01941,0.97057 -1.17763,0.97057 -1.81173,1.38792c-1.06116,-0.23294 -2.00585,-0.32353 -3.04436,-0.59853c-0.54028,-0.52087 -1.2941,-0.48205 -1.94115,-0.73117c-1.2941,-0.15205 -2.19673,-1.21644 -3.27406,-1.90879a18.0203,18.0203 0 0 1 -2.97643,-1.79879c-0.3494,-0.22 -0.7894,-0.26528 -1.1388,-0.47235a0.32353,0.32353 0 0 1 -0.18441,0.07441a1.63703,1.63703 0 0 0 -1.85056,-0.97057a0.97057,0.97057 0 0 0 -0.29763,0.14236c-0.75058,0.71175 -1.75351,0.84763 -2.63996,1.25203c-0.21352,0.07764 -0.61794,0.23294 -0.76999,-0.09382c0.11323,-0.8088 0.71175,-1.42674 0.99969,-2.16114c2.02527,-0.84763 4.08611,0.1553 5.78138,1.00293c0.75381,0.5597 1.46557,1.19704 2.37144,1.38792c1.19704,0.84763 2.33261,1.79233 3.64612,2.46849c0.76999,-0.01941 1.42674,0.32353 2.04468,0.59529c0.57911,0.19412 1.36852,0.13588 1.94115,0.46264c0.32353,-0.03882 0.8088,0.15205 1.0191,-0.22969c0.48528,-0.97057 1.77615,-1.32969 1.75674,-2.54613c1.0191,-1.38792 -0.17471,-2.8729 -0.06146,-4.39346a1.40409,1.40409 0 0 0 0.19088,-1.3491c0.27823,-0.74734 0.35912,-1.47203 0.59853,-2.18702c0.07441,-0.22969 0.72146,-0.78293 0.56294,-1.10321c-0.6697,-0.35264 -1.00616,1.07411 -1.58528,0.88322c-0.54028,-0.24911 0.32353,-0.64705 -0.17471,-0.97057l-1.26821,1.1841l-0.17471,0.16499l-0.36235,0.09705c-0.67293,0.71175 -1.69527,0.71175 -2.21614,1.67585a3.49083,3.49083 0 0 0 -1.05469,0.29441c-0.43353,0.38177 -1.52703,0.41734 -1.52703,0.41734a1.6888,1.6888 0 0 0 -1.03204,0.35587a3.08319,3.08319 0 0 1 -1.1097,0.26206c-0.8088,0.50146 -1.69527,0.22969 -2.58819,0.22969c-0.5047,-0.07764 -0.17471,-0.7344 -0.64705,-0.86704a18.50559,18.50559 0 0 1 -0.86381,-2.61083a8.94545,8.94545 0 0 1 -0.19735,-1.22292c-0.90588,-1.17439 -0.26853,-2.85348 -1.2941,-3.93406c-0.46264,-0.17471 -0.64705,-0.71175 -0.75058,-1.15498c-0.61794,-0.38499 -0.46264,-1.11939 -0.99969,-1.48498c-0.32353,-0.92529 -1.00293,-1.56262 -1.38792,-2.44908l-0.28794,-0.09705c-0.75058,0.4044 -0.4044,1.42674 -0.5597,2.17732c-0.36881,0.38499 -0.05824,0.94469 -0.07764,1.42674c-0.11646,1.54321 -0.50146,2.96995 -0.75381,4.43228c-0.32353,0.68263 -0.05177,1.61762 -0.4044,2.3035a1.20998,1.20998 0 0 1 -0.32353,0.39471a0.64705,0.64705 0 0 1 -0.79263,-0.22969c0,-0.055 0.01618,-0.11 0.02265,-0.16499a29.4407,29.4407 0 0 0 0.34618,-4.20582c0.44323,-0.52087 0.26853,-1.2941 0.52087,-1.88938c0.09705,-0.59853 0.4044,-1.32969 0.07764,-1.85056c-0.5597,0.34618 -0.64705,1.1388 -0.77323,1.79233c-0.34618,1.00293 -0.4044,2.23556 -1.11616,3.14142c-0.1553,0.36558 -0.27176,0.88645 -0.7344,0.92529c-0.75058,-0.28794 0.09705,-1.08057 0.07764,-1.65645c0.77323,-0.59853 0.42381,-1.6985 0.52087,-2.50732c0.17471,-1.00293 1.08057,-1.59821 1.33293,-2.58819c-0.36881,-0.38499 -0.79263,0.13588 -1.23585,0.09705c-0.76999,1.52379 -2.38761,0.75058 -3.46818,1.56262c-0.46264,0.64705 -1.26821,0.64705 -1.67585,0.7894c-0.34294,-0.32353 -0.34294,-0.59529 0,-1.15822a1.41056,1.41056 0 0 0 1.2941,-0.32353c0.97057,-0.1553 1.67585,-0.92529 2.50408,-1.38792c0.64705,-0.54028 1.50439,-0.59853 2.18056,-1.09674c0.17471,-0.03882 0.57911,0.11646 0.64705,-0.23294c-0.77323,-0.94469 0.75381,-0.42381 0.92529,-1.06116c0.28794,-0.88645 1.2941,-0.64705 1.90879,-1.02234c0.27176,-0.07764 0.69558,-0.2103 0.92529,0.03882c0.86704,0.32353 1.04175,1.23263 1.19704,1.98643c-0.07764,0.21352 -0.1553,0.61794 -0.50146,0.52087c-0.23294,-0.44323 -0.46264,-0.90588 -0.69558,-1.3491c-0.2103,0.07764 -0.48205,-0.03882 -0.59529,0.23294c-0.1553,0.54028 0.48205,0.38499 0.64705,0.7894c0.01618,0.76999 0.79263,0.92529 1.2941,1.2941l0.6244,1.28438c0.50146,1.13557 1.1388,2.26468 1.52057,3.42935a18.64793,18.64793 0 0 1 1.85379,5.39639c-0.13588,0.75058 0.6147,1.23263 1.06116,1.67909a3.06377,3.06377 0 0 0 2.50408,-0.75381a23.76609,23.76609 0 0 0 2.58819,-0.7344c0.82822,-0.69234 1.71468,-1.04175 2.46526,-1.85056c0.02265,-0.47558 0.18764,-0.81852 0.11,-1.45262c-0.19088,-1.08704 -0.84439,-0.22323 -1.13233,-0.82176c-0.44323,-0.52087 0.64705,-0.59853 0.26853,-1.15822c-0.71175,-1.11616 -2.18056,-0.84763 -3.18025,-1.46557c-0.76999,-0.64705 -1.00293,-1.52379 -1.53997,-2.26468c-0.38499,-0.38499 -0.97057,-0.32353 -1.46557,-0.42381c-0.71175,-0.26853 -1.04175,-1.17439 -1.85056,-1.15822c-0.90588,-1.06116 -2.14173,-1.2941 -3.06377,-2.3132c-0.23294,-0.11646 -0.79263,-0.07764 -0.64705,-0.54028c-0.71175,-0.6147 -1.65968,-1.17439 -2.37144,-1.85056c-0.3494,-0.13588 -0.64705,0.01941 -0.92529,-0.22969c-0.09705,-0.76999 -1.06116,-0.61794 -1.61762,-0.88645c-0.6147,-0.97057 -2.02527,-0.5597 -2.35202,-1.71468c-1.32969,0.01941 -2.33261,-0.8088 -3.52965,-1.15822a2.73701,2.73701 0 0 1 -1.21322,-0.77323a0.97057,0.97057 0 0 1 0.30087,-0.7894c0.86704,0.52087 1.66291,0.77323 2.52996,1.23585c0.59853,0.01941 1.06116,0.32353 1.58203,0.46264c1.50439,0.17471 2.48467,1.59821 3.83699,2.1385c0.8088,-0.25235 1.11939,0.64705 1.75674,0.92529c0.49823,0.13588 0.86704,0.7894 1.38792,0.97057c0.59853,0.5597 1.40733,0.76999 2.04468,1.2941c0.57911,0.61794 1.07734,1.75351 2.08027,1.61762c0.76999,0.24911 0.99969,1.05793 1.61762,1.48498c0.75058,-0.23294 1.27144,0.36558 1.85056,0.69558c0.08412,0.35264 0.42058,0.57263 0.72469,0.80558c0.37853,0.28794 0.71499,0.59204 0.46911,1.18087c0.38499,0.4044 0.2103,-0.52087 0.69234,-0.46264c0.11646,0.05824 0.09705,0.17471 0.09705,0.28794l0.75381,0c0.59529,0.4044 0.94469,1.09998 1.38792,1.65968c0.26853,0.34618 0.59529,-0.28794 0.82822,0.19412c0.75381,0.05824 1.04175,0.90588 1.79233,0.97057c0.69558,-0.17471 1.42674,0.07764 2.04468,0.32353c0.52087,0.03882 0.50146,0.61794 0.73117,0.92529c0.64705,-0.4044 1.4688,-0.38499 2.26468,-0.36558a0.64705,0.64705 0 0 1 0.35587,0.27823a4.222,4.222 0 0 0 1.59497,0.32353a13.09303,13.09303 0 0 0 1.54321,0a6.89431,6.89431 0 0 1 1.48174,-0.06146c1.07086,-0.12618 1.39762,0.17795 1.49792,0.35587a1.43321,1.43321 0 0 1 0.32353,0.29763c0.23294,-0.22969 0.23294,-0.75381 0.69234,-0.69558c0.01941,0.05824 0.11646,0.07764 0.09705,0.13588c0.11646,0.05824 0.19412,-0.05824 0.27176,-0.13588c0.69234,-0.01941 0.97057,-0.75058 1.61762,-0.86704c0.29117,-0.09705 0.50146,-0.57911 0.82822,-0.42381c0.64705,-0.5597 1.42674,-0.07764 2.18056,-0.22969c1.25203,-0.36558 2.65937,-0.32353 3.6623,-1.2941c0.34618,-0.13588 0.82822,0.07764 1.06116,-0.32353a4.82698,4.82698 0 0 0 1.56262,-0.59853c0.71175,-0.36558 0.54028,-1.23263 0.69234,-1.90879l0.055,0l0,-0.57263c-0.42381,-0.5597 -0.09705,-1.46557 -0.64705,-1.90879c-0.94469,0.05824 -0.90588,-1.3491 -1.88938,-1.1938c-0.64705,0.07764 -1.32969,-0.19088 -1.98643,-0.09705c-1.17439,0.82822 -3.00554,1.25203 -3.33554,2.91172c-0.30735,0.2103 -0.75058,0.46264 -0.51764,0.92529a0.62116,0.62116 0 0 1 -0.59853,0.28794c-0.48205,-0.23294 -0.26853,-0.86704 -0.32353,-1.25203a1.73733,1.73733 0 0 0 0.19412,-1.02234l-0.27176,0.03882c-0.36558,0.38499 -0.76999,0.11646 -1.0191,-0.23294c-0.67616,0.42381 -1.1388,1.04175 -1.85056,1.21644a3.88229,3.88229 0 0 1 -1.52379,-0.75058c-0.36558,0.1553 -0.77323,-0.27176 -1.08057,0a9.03604,9.03604 0 0 1 -1.06116,-1.56262l0.05824,-0.05824c-0.13588,-0.01941 -0.4044,-0.17471 -0.28794,-0.36558c0.05824,0 0.14236,-0.01618 0.19412,0a3.61053,3.61053 0 0 1 -0.88645,-2.46201c-0.52087,-0.75058 -0.48205,-1.71468 -0.92529,-2.50408c-1.08057,-1.11939 -1.38792,-2.64319 -1.94115,-4.0117c0.17471,-0.32353 0.42705,-0.76999 0.8897,-0.64705c0.75381,0.5597 1.71468,0.57911 2.50732,1.06116c0.07764,0.17146 0.36558,0.52087 0,0.64705c-0.50146,-0.2103 -1.21644,0.25235 -1.58203,-0.42381a0.56617,0.56617 0 0 0 -0.50146,0.22969a0.8088,0.8088 0 0 0 0.50146,0.64705c0.21352,0.7894 0.86704,1.44615 1.06116,2.21614c0.50146,0.25235 0.15205,0.92529 0.64705,1.19704c-0.17146,0.44323 0.28794,0.75058 0.13588,1.25203c0.46264,0.28794 0.38823,0.88645 0.73117,1.25528c0.38823,1.11616 1.00293,2.29378 2.14173,2.91172a2.24202,2.24202 0 0 0 0.59529,-0.23294l-0.04528,-0.03235a2.70467,2.70467 0 0 1 0.72469,-0.19088l-0.0001,0.00002l-0.00006,-0.00008l0.00004,0.00005z",
    id: "core",
    stroke: "null"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "m37.01305,9.09404a1.24881,1.24881 0 0 0 -0.14558,-0.10353c0.01941,-0.11646 -0.03559,-0.26853 0.04206,-0.36558c0.4594,-0.75058 0.84763,0.24911 1.44615,0.13264a1.91526,1.91526 0 0 0 -1.11939,-1.71468c-0.07764,-0.46264 -0.76999,-0.5597 -0.88645,-1.06116c-0.44323,0.01941 -0.54028,-0.69558 -1.00293,-0.59853c-0.24911,0.13588 -0.64705,0.25235 -0.69234,0.5597c0.59853,1.14528 0.87998,2.47819 1.66291,3.50376c0,-0.0097 1.08704,0.54352 0.69558,-0.35264l-0.00001,0l0,0.00001l0,0.00001z",
    id: "eye",
    stroke: "null"
  }))));
};

const ArcteryxLogoOutlet = _ref => {
  let {
    width,
    height,
    title
  } = _ref;
  return /*#__PURE__*/React__default.createElement("svg", {
    id: "birdword",
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 892.31 335.94"
  }, /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("path", {
    d: "M210.31,462.86c.77-.44,1.53-.91,2.3-1.29,2.81-.91,4-4.32,7.28-4,3-3.34,7.35-4.09,10.77-6.75a3.76,3.76,0,0,1,1.11-1.74c2.15-1.64-1.46-2.92-1.46-2.92-1.05-1.4-2.64-.11-2.64-.11a19.49,19.49,0,0,1-2.47,1.29c-.46,1.59-2.13,1.74-3.34,2.42a31,31,0,0,1-6.14,4.17c-1.53,2.29-4.23,2.72-6,4.46a8.56,8.56,0,0,0-2.86,3.17s-4.2,3.85,1.4,1.75Z",
    transform: "translate(-61.44 -336.09)"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M205.1,469.12a3.08,3.08,0,0,1-.3.41.35.35,0,0,1-.21.15c-2.84,2.06-4.59,4.78-6.35,7.49-1.89,2.89-3.79,5.77-7.08,7.83-2.43,0-3.8,2.5-5.84,3.48-.61-.15-.76-.83-1.06-1.29a7.48,7.48,0,0,1-.75-4.73,6.92,6.92,0,0,0,3.48-1.79c1.31-1.11,2.62-2.29,3.92-3.5,4-3.74,7.9-7.79,11.84-11.28C202.75,465.89,205.8,464.44,205.1,469.12Z",
    transform: "translate(-61.44 -336.09)"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M204.27,460.28c-4.55,1.82-9.93,1.82-13.49,5.46-1.67.91-4.55-.68-5.61,1.44.3.53.07,1.36.15,2l-1.67-.15.38,3.26c4,.53,6.14-4.63,10-5.08l.53.53v1.14c-.61.38-1.44-.61-2.13,0a21.28,21.28,0,0,1-7.12,4.85c-.61.36-.63,1.6-1.24,1.69l-.58,4.53c2.24.54,3.85-1.24,5.5-2.75a12.9,12.9,0,0,1,1.24-1c4-4.4,9.25-7.81,12.36-12.59C202.6,463.54,203.78,464.27,204.27,460.28Z",
    transform: "translate(-61.44 -336.09)"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M299.14,459.45c.38,5.9-2.32,10.43-6.32,14.86-4.09,1.06-8.11,4.09-12.35,1.59-2.66-1.44-5.84.15-7.81-2.88-.91-.31-2.2-.08-2.58-1.29.53-1.29,2.23-1.31,3.22-2.22,4.85.61,11,4.47,15.24.15,1.82-.83,4.54-1.06,4.77-3.64.08-1.67.38-3.41,1.82-4.4,1.5-.06,1.7-1.86,2.17-3.18,0,0-.14-4.6,1.61-3.9,0,0,1.61,1.7,0,2.8Z",
    transform: "translate(-61.44 -336.09)"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M263.22,436.06c-1.49,1.4-3.11,2.69-3.83,3.45-6.07,2.12-12.89,3.41-19.11.75-.83-1.44,1.57-2.05.13-3.42.53-.53.79-1.07,1.62-.77.84,2.28,3.41,1.16,5.15,1.47,2.51.9,4.63-.91,6.9-.54,1.6-.75,2.43-.75,4-1.51a1.61,1.61,0,0,0,.92-.17S264.27,431.93,263.22,436.06Z",
    transform: "translate(-61.44 -336.09)"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M392.48,428.06c-2.8-2.57-5.16,1-5.16,1a5.56,5.56,0,0,0-2,2.47c-3.79,1.82-5.46,6.82-9.32,8.34-2.35,2.35-5.24,3.86-7.81,6.52-5.08,1.51-11.53,2-16.53,4.54-3.87,1.52-8,2.2-11.83,3.64-4.62,3.11-10,4.17-14.55,7.28-.76.68-2.58,1.06-2,2.58.68,1.06,2,.23,2.95.76s3,.38,2.89,2c-1,.91-3.11.83-2.89,2.73,1.6,1.21,3.87,2,5.77,2.88a40.33,40.33,0,0,0,8,4.38c4.75,2,9.74,3.48,14.43,5.63,3.71,1.13,8,1.36,11.22,3.33,4.4,1.22,9.17,2.66,13.87,3.64,2.88,1.14.16,3.64.69,5.77-.08,1.44-1.29,2.57-.69,4-2.27,3.49-2.42,7.58-2,11.68-1.14.45-.61,1.67-.31,2.35a22.35,22.35,0,0,0-1.82,7.13c-.53-.16-.83.38-.91.68-.37,3.49-.75,6.22-1.13,9.63a8.35,8.35,0,0,0,6.9-.53c-1.22-2.58.75-4.78.6-7.43.84-1.6.23-3.11.68-4.93,2.05-6.37,2.13-13.12,2.73-19.87-.3-1.06-1.13-1.89.38-2.72l.76.75c-.61,2.35.38,4.93-.23,7.13,1.52,4.62.16,9.78.91,14.71,3.19,1.74-1,5.15,2.2,6.9a3.66,3.66,0,0,0,1.18,2.94c1.34.29,3-.3,4.81-2.18.46-4.48-2.12-7.66-2.2-11.83-1-2.88-.45-5.61-2.12-8.19-.08-2.5-1.06-5-1.29-7.51-1.29-1.06-.68-3.26-.53-4.7-.45-2.65-.3-6.44-3.64-7.65-5.68-.61-11.07-2.89-16.6-4.33-3.34-.68-6.6-2.57-10.16-3.1a31.42,31.42,0,0,0-3.75-1.31c-3.15-.93-6.35-1.62-9.22-3.24-.77-.22-1.54-.46-2.29-.73l-.54-.29c-1.2-.66-8.24-2.9-9.34-3.67-1.28-2,1-2,1-2,.44-.11,6.49,2.88,6.93,2.88,1,.15,1.41.8,2.35,1a30.18,30.18,0,0,0,3.56,1c4,2.43,8.59,3.71,13.11,5.06,1.4.42,2.8.84,4.18,1.31.3.53,1.67.45,2.35.91,2.8,1.21,6.14,1.13,8.72,2.88,1.82-.91,2.8,1.21,4.39,1.29,2.66,1.36,6.37.07,8.57,2.57,2.2,3.19,1.59,7.58,3.26,11.07-1.44,2.81,2.73,3.95,1.29,6.75.68,1.52,1.44,3.72,3.26,4.17a2.94,2.94,0,0,0,2.88-1.06c.23-1.9-1-3.19-1.44-4.78.46-3-2.12-5.61-2-8.57-.3-2-.61-4.54-2.58-6-1-2-3.1-4.06-1.82-6.48-.68-.69-1.89.15-2.73-.38-2.19-1.52-4.92-1.6-7.5-2.05a29.07,29.07,0,0,0-6.84-2.9A44.13,44.13,0,0,0,366,474.5v-.38c-2.35,1-4.63-2.05-7.13-2.58-1.51-1.36-4.55-.07-6.21-1.82A6.92,6.92,0,0,1,348,468.6c-1.82-.23-4.79.21-5.7-1.91a18.39,18.39,0,0,0-5.66-1c-.44-.2-.9-.4-1.4-.67a3,3,0,0,0-1.24-.49c-1.29.06-3-.68-2.63-1.23.17-.26,3.36-1,3.65-1.26a3.27,3.27,0,0,0,1.27-.45l.1,0c6.12-2.34,12.46-4.08,18.27-7,4.47.23,8.42-1.74,13-1.82,4.85-3.48,8.56-9.17,14-11.6,2.28-1.81,3.94-6.9,7.43-5.3,1.37-.38,2.13.53,3.49.22,1-1.22,2.53-2.5,2.19-4.06C395,430.63,392.48,428.06,392.48,428.06Zm-6.66-68.47a2.11,2.11,0,0,1,.54,1.32c-.11,5.2.14,11.34,2,16.2,1.67,6.82,3.11,13.42,4.55,20.39.61,3.11-4.77,3.26-3.26,6.37.46,2.88-1.29,3.79-2.88,5.84a22.75,22.75,0,0,1,2.45,2,3.47,3.47,0,0,0,4.43,1.63s3-.86,2.68-3.46c.24-2.26.3-4.82,1.74-6.25-.68-1.9.61-3.87-.91-5.46.45-4.1-1.44-7.59-2.58-11.22.23-2.58-1.14-4.63-.91-7A137.58,137.58,0,0,1,390,361.11l.76-1.14c2-.53,2.5,2.2,4.32,2.58.91,3.11,4.1,4.4,5.46,7.13a111.61,111.61,0,0,1,13.27,14.18c5.38,5.08,10.61,9.63,14.93,15.24,1.52,1.51,3.64.07,5.31,1.28,2.5-1.36,7.74-.45,7.28-4.92a2.76,2.76,0,0,1,2.2-.91c2.12,1.21,4.62-.08,6.67-.69a108.83,108.83,0,0,0,16.38-2.57c1.13-.08,1.51-1.14,1.29-2.2a2.68,2.68,0,0,0-2.2-1.44c-5.39,1.29-10.92,3.41-16.53,3.11l-.53-.38c.53-1.59,2.88-.53,4-1.59,3.33-.31,8-.84,11.45-2.43,2.5-2.43,6.06,2,7.65-2.35.84-1.9,6.29-1.59,3.64-4.32-1.67-.23-3.33-.69-4.4,1.21-3.33-.68-5.08,2.73-8.18,2.58-.31-.08-.76-.31-.53-.76,3.94-2.27,8.56-3.11,12.35-5.76.15-.76-.22-1.29-.91-1.29-5.83,1.36-11.06,4.32-16.52,6.52-1.6,1-3,3-5.16,3-3,2-6.75,2.42-9.4,5.23-1.67.38-3-.38-4.4.53a13.79,13.79,0,0,1-4-3.79c-5.46-6-12.89-11.22-18.57-17.67-5.38-3.71-10.84-7.66-15.09-12.51l-3.26-2.73a3.45,3.45,0,0,0-3.39,1.38c-.09.06-.13.17-.2.26a2.14,2.14,0,0,1-.45.17c-.33,0-.66,0-1,0a8.64,8.64,0,0,1-1.06-.22,2.38,2.38,0,0,1-1.1-.66,6.34,6.34,0,0,1-2.53.16s-2.34-.93-1.64,1.63A4.36,4.36,0,0,1,385.82,359.59Zm46.43,35.18c-1.14.23-.76-1.13-1.67-1.44-3.48-2.65-6.44-6.67-9.78-9.7-1.66-1.29-2.8-3.49-4.77-4.55-5.46-4.47-10.16-10.61-15.47-14.86a22.78,22.78,0,0,0-4.71-5.31,1.6,1.6,0,0,1,.68-1.66c.83,0,1.74.3,1.67,1.29,4.08,5.94,9.85,8.21,15.33,15.69.91-.23.83.53,1.06,1.21,6.14,6.07,13,11.83,19.1,17.89C433.92,394.32,432.71,394.32,432.25,394.77Z",
    transform: "translate(-61.44 -336.09)"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M333.49,377.58c2.7-.66,6.25-3.63,8.31-.47.31.15.53-.15.76-.38.83.23.83,1.14,1.06,1.82.46.23.61-.38.91-.53,0-1.82,1.37-2.5,2.58-3.79a45,45,0,0,1,6.67-2.58c-.23-1.14-.6-1.74-1.82-2,0,.38-.45.61-.68.91-2.65.07-3.34,3.33-6,2.88l-.23-1.44c2.28-1.44,3.41-4,4.17-6.37-.83-1.44-3,0-4.17-.23-1.29-1.89-3.64-2.12-6-2-2.27-2.5-4.17-5.68-7.81-6-1.13-1.21-2.19-2.42-2-4.17.83-2,2.5.38,3.86.31,6.9,2.35,12.51,8.56,20.17,9.32,1.44,2.66,4.85,2.28,7.51,2.88,1.82,2.05,4.55,1,7.27,1.29,3.26,1.52,7.51.76,10.92,2,.91.91.84,3.41,2.73,2.73.68,2.81,2.81,4.63,3.79,7.13,2.73,2.05,1.52,5.91,1.82,8.72.76,1.82-.3,3.64,1.29,5.08a8.41,8.41,0,0,1-4.55,7.65c-1.29,3.27-5.38,2.05-8,3.11-2,1.9-4.25,2.28-6,4.4-1.44,2.58-3.19,5.31-2.73,8.49a14.83,14.83,0,0,1-.64,5.42c-.64,2.36-1.45,4.6-1.18,7-.91,2.65,0,6.74-3.64,7.58-.61-.38-2-.68-1.67-1.82-1.82-.84.3-2.88-1.44-3.94l.76-5.46a22.13,22.13,0,0,0,1.17-3.38c1.29-4.73,1.6-9.83,5.2-13.61-.08-1.06-1.14-1.44-2.2-1.21l-7.13,5.46c-2.32,2.61-2.67,6-3.27,9.36-.49,2.76-1.15,5.45-3.25,7.55-.45,3.64,1.74,7.12.15,10.38-1.29.38-2.88,1.6-4.17.31-2.73-5.31-.53-11.83,1.67-16.68a7.9,7.9,0,0,0,1.08-1.56c1.93-3.58,1.73-8.41,6.2-10.12,0-.68,0-1.44-.76-1.67l-2.88,1.67c-1.14.61-2.65.15-3.64,1.06-1.77,3-4.05,5.7-4.73,9.06-4.09,5.23-2.47,13.16-4.37,19.37l-1.82,2a2.21,2.21,0,0,1-2.57-.54c-1.14-4,.68-7.65.53-11.67.53-2.81.91-5.76,2.95-8a4.63,4.63,0,0,1,0-1.18c.47-3.11,4-4.92,5.58-7.77l-.53-1.06c-1.21-.08-1.36,1.29-2,2a24.84,24.84,0,0,0-6.14,6.86c-.8,1.21-1.55,2.42-2.27,3.53-2.81,3.11-3.26,7.2-4.33,11.07-1.82,2.65.53,6.67-2,8.56a4.64,4.64,0,0,1-3.79,0c-1.22-1.51-.08-3.48.15-5.07.76-2.81.53-6.52.91-9.25a55,55,0,0,1,6.44-8.84,44.63,44.63,0,0,1,3.79-3.75v-2c-1.13-.38-2.2,1.14-2.95,1.82-1,1.31-2,2.6-3.1,3.9-5.75,7-12.11,14.14-10.7,24.3-1,1.29-2.58,1.22-4,1.44-1.74-.38-1.9-2.35-2-3.86,1.44-4.25.45-9.63,4.32-12.74-.3-3.72,3.79-4.85,5.08-7.81,1,.05,1.25-.89,1.72-1.33a.86.86,0,0,1,1-.11c-.15-1.67,1.06-2.73,1.29-4.17-.38-.46-.38-1.21-1.29-.91a33.3,33.3,0,0,0-6.23,5.19,41.61,41.61,0,0,0-9.77,18.46c-1,2.51-.83,5.54-2.88,7.66-1.36.31-3,.31-4-.76-.83-5.68,2-10.23,3.64-15.08.91-1.29-.38-3.49,1.06-4.55,1.9-1.9,3.19-3.79,4.78-5.69,1.68-1.55,5-1.16,5.48-3.79-.11-2.54-4.33-1.19-4.33-1.19-.7.7-3,.47-3,.47a2.22,2.22,0,0,0-1.86,0c-1.05,1-4.55,1.69-6.27,2a22.14,22.14,0,0,0-2.16,2.51c-1.21,2.13-2.23,4.82-1.32,7.32a57.05,57.05,0,0,0-.53,9.48,32.56,32.56,0,0,1,.94,7.84l.12,2.85,2.1,1a6.36,6.36,0,0,0-1.8,2.73c-1.26,1.82-1.46,4.22-2.27,6.3a12.48,12.48,0,0,0-2.73,4.32c.08,3.79-4.62,3.87-7.12,5.46-4.17-.91-7.89-1.21-12-2.35-2.13-2.05-5.08-1.9-7.66-2.88-5.08-.61-8.64-4.78-12.89-7.51-3.94-2.12-8-4.09-11.67-7.05-1.38-.87-3.1-1.05-4.48-1.86a1.22,1.22,0,0,1-.73.29A6.44,6.44,0,0,0,228,444a3.69,3.69,0,0,0-1.17.56c-3,2.8-6.9,3.33-10.39,4.92-.83.31-2.42.91-3-.37.45-3.19,2.8-5.62,3.94-8.5,8-3.33,16.07.61,22.75,3.95,2.95,2.19,5.76,4.7,9.32,5.46,4.7,3.33,9.18,7.05,14.33,9.7,3-.08,5.61,1.29,8,2.35,2.27.76,5.38.53,7.66,1.82,1.21-.15,3.18.61,4-.91,1.9-3.79,7-5.23,6.9-10,4-5.46-.68-11.29-.22-17.28a5.54,5.54,0,0,0,.75-5.31c1.1-2.94,1.4-5.78,2.35-8.61.3-.9,2.85-3.08,2.22-4.33-2.64-1.39-4,4.22-6.23,3.46-2.13-1,1.21-2.5-.69-3.79l-5,4.66-.69.65-1.44.3c-2.66,2.81-6.68,2.81-8.72,6.6a13.9,13.9,0,0,0-4.15,1.15c-1.7,1.52-6,1.64-6,1.64a6.64,6.64,0,0,0-4.06,1.4,12,12,0,0,1-4.37,1c-3.18,2-6.67.91-10.16.91-2-.31-.68-2.88-2.57-3.41a72.41,72.41,0,0,1-3.41-10.28,34.21,34.21,0,0,1-.76-4.81c-3.57-4.63-1.07-11.22-5.08-15.47-1.82-.68-2.51-2.8-3-4.55-2.43-1.51-1.82-4.39-3.94-5.83-1.29-3.64-3.95-6.15-5.46-9.63l-1.14-.38c-3,1.59-1.59,5.61-2.2,8.56-1.44,1.52-.23,3.72-.3,5.62-.46,6.06-2,11.67-3,17.43-1.31,2.69-.21,6.4-1.59,9.06a4.72,4.72,0,0,1-1.29,1.56,2.54,2.54,0,0,1-3.11-.91l.09-.65a114.56,114.56,0,0,0,1.35-16.49c1.75-2,1.06-5.08,2-7.43.38-2.35,1.59-5.23.3-7.28-2.2,1.37-2.57,4.48-3,7.06-1.36,3.94-1.59,8.79-4.4,12.35-.6,1.44-1.06,3.49-2.88,3.64-2.95-1.13.38-4.24.31-6.52,3-2.35,1.66-6.67,2-9.85.68-3.95,4.25-6.3,5.23-10.16-1.44-1.52-3.1.53-4.85.38-3,6-9.4,2.95-13.65,6.14-1.82,2.57-5,2.54-6.59,3.11-1.34-1.31-1.34-2.35,0-4.55,1.51.3,3.79.15,5.08-1.29,3.79-.61,6.59-3.64,9.85-5.46,2.58-2.12,5.92-2.35,8.57-4.32.68-.15,2.28.45,2.5-.91-3-3.72,3-1.67,3.64-4.17,1.14-3.49,5.08-2.58,7.51-4,1.06-.3,2.73-.83,3.64.15,3.41,1.21,4.09,4.85,4.7,7.81-.31.83-.61,2.43-2,2.05-.91-1.75-1.82-3.57-2.73-5.31-.84.3-1.9-.15-2.35.91-.61,2.12,1.89,1.52,2.5,3.11.07,3,3.11,3.64,5.08,5.08l2.58,4.93c2,4.47,4.47,8.94,6,13.49A73.36,73.36,0,0,1,245,425.48c-.53,3,2.43,4.85,4.17,6.6a12.07,12.07,0,0,0,9.86-3,94.8,94.8,0,0,0,10.16-2.88c3.26-2.73,6.75-4.1,9.7-7.28.09-1.87.74-3.22.44-5.72-.75-4.27-3.32-.88-4.45-3.23-1.75-2,2.5-2.35,1.06-4.55-2.81-4.39-8.57-3.33-12.51-5.76-3-2.58-3.94-6-6.07-8.94-1.51-1.52-3.79-1.29-5.76-1.67-2.8-1.06-4.09-4.63-7.28-4.55-3.56-4.17-8.41-5.08-12.05-9.1-.91-.45-3.11-.3-2.5-2.12-2.81-2.43-6.52-4.63-9.33-7.28-1.36-.53-2.5.08-3.64-.91-.38-3-4.17-2.43-6.37-3.49-2.42-3.86-8-2.2-9.25-6.74-5.23.07-9.17-3.19-13.87-4.55a10.74,10.74,0,0,1-4.77-3,3.83,3.83,0,0,1,1.18-3.11c3.41,2.05,6.54,3,10,4.86,2.35.07,4.17,1.21,6.21,1.82,5.92.68,9.78,6.29,15.09,8.41,3.19-1,4.4,2.5,6.9,3.64,2,.53,3.41,3.11,5.46,3.79,2.35,2.2,5.53,3,8,5.08,2.27,2.43,4.24,6.9,8.18,6.37,3,1,4,4.17,6.37,5.84,3-.91,5,1.44,7.28,2.73.34,1.38,1.65,2.26,2.85,3.17,1.5,1.13,2.82,2.32,1.85,4.64,1.52,1.59.84-2.05,2.73-1.82.46.23.38.68.38,1.13h3c2.35,1.6,3.71,4.33,5.46,6.52,1.06,1.37,2.35-1.13,3.26.76,2.95.23,4.09,3.57,7.05,3.79,2.73-.68,5.61.31,8,1.29,2.05.15,2,2.43,2.88,3.64,2.58-1.59,5.79-1.51,9-1.44a2.6,2.6,0,0,1,1.39,1.1,16.73,16.73,0,0,0,6.28,1.27,49.52,49.52,0,0,0,6.06,0,27.85,27.85,0,0,1,5.84-.23c4.22-.51,5.5.69,5.89,1.4a5.93,5.93,0,0,1,1.28,1.16c.91-.91.91-2.95,2.73-2.73.08.23.46.31.38.53.46.23.76-.22,1.06-.53,2.73-.07,3.8-2.95,6.37-3.41,1.14-.38,2-2.27,3.26-1.67,2.51-2.2,5.61-.3,8.57-.91,4.93-1.44,10.46-1.21,14.41-5.08,1.36-.53,3.26.31,4.16-1.29a19,19,0,0,0,6.15-2.35c2.8-1.44,2.12-4.85,2.73-7.5h.22v-2.12c-1.66-2.2-.38-5.77-2.57-7.51-3.72.23-3.57-5.31-7.43-4.7-2.58.3-5.24-.76-7.81-.38-4.63,3.26-11.83,4.93-13.12,11.45-1.21.83-3,1.82-2,3.64a2.41,2.41,0,0,1-2.35,1.13c-1.89-.9-1.06-3.41-1.29-4.92.84-1.14.76-2.81.76-4l-1.06.15c-1.44,1.52-3,.46-4-.91-2.65,1.67-4.47,4.09-7.28,4.78-2.12-.69-4.39-1.44-6-3-1.44.61-3-1.06-4.24,0a34.88,34.88,0,0,1-4.17-6.14l.23-.23c-.53-.07-1.6-.68-1.14-1.44.23.06.56-.06.76.06a14.27,14.27,0,0,1-3.49-9.69c-2.05-2.95-1.9-6.75-3.64-9.85-4.25-4.4-5.46-10.39-7.66-15.77.69-1.29,1.67-3,3.49-2.58,3,2.2,6.75,2.27,9.86,4.17.3.68,1.44,2.05,0,2.58-2-.84-4.78,1-6.22-1.67a2.23,2.23,0,0,0-2,.91,3.17,3.17,0,0,0,2,2.58c.83,3.1,3.41,5.68,4.17,8.71,2,1,.61,3.64,2.58,4.71-.68,1.74,1.13,2.95.53,4.92,1.82,1.14,1.51,3.49,2.88,4.93,1.52,4.4,3.94,9,8.41,11.45a8.64,8.64,0,0,0,2.35-.92l-.18-.13A10.65,10.65,0,0,1,333.49,377.58Z",
    transform: "translate(-61.44 -336.09)"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M327.28,371.67a5,5,0,0,0-.57-.4c.08-.45-.15-1.06.16-1.44,1.82-3,3.33,1,5.68.53a7.54,7.54,0,0,0-4.39-6.75c-.31-1.82-3-2.19-3.49-4.17-1.75.08-2.12-2.73-3.94-2.35-1,.53-2.51,1-2.73,2.2,2.35,4.51,3.46,9.75,6.54,13.79C324.54,373.08,328.81,375.25,327.28,371.67Z",
    transform: "translate(-61.44 -336.09)"
  }), /*#__PURE__*/React__default.createElement("polygon", {
    points: "202.94 245.21 202.94 268.36 216.93 245.21 202.94 245.21"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M358.93,619.34l16.51,0c3.29,0,10.27.17,11.89-.23s2.24-1.44,2.63-1.32.22.67.22.67c0,2.54,0,1.73,0,5,0,3.61.2,2.21.2,4.86,0,0,.18.57-.21.68s0-.45-2.14-1.16-9.27-.48-12.56-.48H358.93l0,25.94h23.45a31,31,0,0,0,8.66-1.08c1.41-.54,2.65-1.87,3-1.76s.22.68.22.68c-.2,2.64-.5,5.06-.91,8.22l-.21,2.37H353.93c-3.61,0-3.85.31-6.5.31,0,0-.57.17-.68-.22s.22-.12,1.16-2.13c1-2.18,1.07-6.28,1.07-9.57,0-6.15,0-16.66-.05-26.73s.06-17.93.05-24.09c0-3.28-.05-7.39-1.07-9.56-.94-2-1.27-1.75-1.16-2.14s.68-.21.68-.21c2.65,0,2.89.3,6.5.3h24.2c6.79,0,10.09,0,14.12,0l0,2.37c0,3.19,0,4.77,0,7.36,0,0,.18.57-.21.68s-1.15-.86-2.56-1.4a30.63,30.63,0,0,0-8.62-1.08H359Z",
    transform: "translate(-61.44 -336.09)"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M98.86,587.33s18.5,42.87,26.76,61.57a79.37,79.37,0,0,0,5.58,10.72c1.73,2,2,2,2,2s-6.45-.18-9.7-.18-5.13.42-5.07.18c.72-1.87.6-3.73-.42-6.21-.21-.49-1.63-3.86-2.28-5.43-5.63-13-18.14-42.14-18.14-42.14-.82-2.05-.14-2.05-1.13,0,0,0-12.51,29.13-18.14,42.14-.65,1.57-2.07,4.94-2.28,5.43-1,2.48-1.14,4.34-.42,6.21.06.24-1.2-.18-4.46-.18s-9.71.18-9.71.18.26.06,2-2A78.16,78.16,0,0,0,69,648.9c8.27-18.7,26.76-61.57,26.76-61.57C96.72,585.12,97.75,585,98.86,587.33Z",
    transform: "translate(-61.44 -336.09)"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M307.15,596.06c0,6.15,0,40.54,0,53.67,0,3.29,0,7.36-1.05,9.53s-1.27,1.75-1.16,2.14.68.22.68.22c2.65,0,3.19-.31,6.8-.31,3.25,0,3.86.24,6.39.24,0,0,.57.18.68-.21s-.86-1.14-1.4-2.56-.89-5.83-.89-9.12c0-13.56,0-49.65,0-53.6H328c3.29,0,9.11.38,10.68,1,1.41.54,2.16,1.51,2.55,1.4s.22-.67.22-.67c0-2.54,0-6.92,0-10.17H280.91c0,3.25-.8,8-.8,10.57,0,0-.18.56.21.68s1.15-.87,2.56-1.4c1.57-.6,8-1.19,11.29-1.19l13-.21",
    transform: "translate(-61.44 -336.09)"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M483.71,625.33v20.55c0,3.29-.18,11.33-1.2,13.5s-1.27,1.75-1.16,2.14.68.22.68.22c2.65,0,3.25-.31,6.86-.31,3.25,0,4.22.25,6.75.25,0,0,.57.17.68-.22s-.86-1.14-1.4-2.56S494,653.25,494,650l0-24.63s22.57-35.26,24.17-35.51a5,5,0,0,0,3.58-2.07l-9.61,0c-3.26,0-6.74-.42-6.68-.18.6,1.69.32,3.64-1,5.93s-14.08,22.3-14.92,23.15c-.84-.85-14-20.56-15.3-22.85a7.11,7.11,0,0,1-.9-6c.06-.24-4.46.18-7.72.18s-9.71-.18-9.71-.18.77.1,2.78,1.87S483.71,625.33,483.71,625.33Z",
    transform: "translate(-61.44 -336.09)"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M551,624s22.85,33.88,24.9,35.68,2.77,1.87,2.77,1.87-6.45-.18-9.7-.18-7.9.42-7.84.18a7.08,7.08,0,0,0-.91-6c-1.32-2.29-14.13-21.75-15-22.59-.85.84-13.57,20.3-14.9,22.59a7.11,7.11,0,0,0-.9,6c.06.24-3.66-.18-6.91-.18s-9.71.18-9.71.18.77-.09,2.77-1.87,24.62-35.17,24.62-35.17-21.71-33.45-24.62-35c-2.35-1.27-2.06-1.87-2.06-1.87s5.74.18,9,.18,7.78-.42,7.72-.18a7,7,0,0,0,.9,6C532.53,596,545.15,615,546,615.85c.85-.84,13.15-19.6,14.47-21.89s1.71-4.64,1.11-6.33c-.06-.24,4.18.18,7.44.18s8.9-.18,8.9-.18a19.32,19.32,0,0,0-3.38,2.47C572.48,591.91,551,624,551,624Z",
    transform: "translate(-61.44 -336.09)"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M427.12,628.12s18.58,26.32,20,28.53a13.82,13.82,0,0,0,11.6,6.39,42.12,42.12,0,0,0,5.89-.36s-.45,0-2.42-1.87c-3.77-3.47-22.47-30.19-22.47-30.19,8-3.42,17-8.81,16.58-21.2-.58-17.87-12.78-22.41-31.47-21.89-2.27.06-7.34.11-10.12.09-3.6,0-4.81-.29-7.46-.29,0,0-.56-.18-.68.21s.86,1.17.86,1.17c1.56,2.12,1.57,12.11,1.57,15.4,0,7.17.07,40.58.06,45.73,0,3.29-.07,7.37-1.09,9.54s-1.27,1.75-1.16,2.14.68.22.68.22c2.65,0,3.62-.31,7.22-.31,3.25,0,3.62.25,6.16.25,0,0,.56.17.67-.22s-.86-1.14-1.4-2.56-.88-5.83-.88-9.12c0,0,.06-48.73.06-53.61,0-3.4,1.69-3.68,5.94-3.73,14.3-.17,20.65,7.33,20.72,17.73C446.11,621.77,439.82,627.23,427.12,628.12Z",
    transform: "translate(-61.44 -336.09)"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M154.59,628.12s18.58,26.32,20,28.53a13.82,13.82,0,0,0,11.6,6.39,42.29,42.29,0,0,0,5.89-.36s-.46,0-2.42-1.87c-3.77-3.47-22.47-30.19-22.47-30.19,8-3.42,17-8.81,16.58-21.2-.58-17.87-12.78-22.41-31.47-21.89-2.27.06-7.35.11-10.12.09-3.61,0-4.81-.29-7.46-.29,0,0-.57-.18-.68.21s.86,1.17.86,1.17c1.56,2.12,1.57,12.11,1.57,15.4,0,7.17.06,40.58.06,45.73,0,3.29-.07,7.37-1.09,9.54s-1.27,1.75-1.16,2.14.68.22.68.22c2.65,0,3.61-.31,7.22-.31,3.25,0,3.62.25,6.15.25,0,0,.57.17.68-.22s-.86-1.14-1.4-2.56-.89-5.83-.89-9.12c0,0,.07-48.73.07-53.61,0-3.4,1.69-3.68,5.93-3.73,14.31-.17,20.65,7.33,20.73,17.73C173.58,621.77,167.28,627.23,154.59,628.12Z",
    transform: "translate(-61.44 -336.09)"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M259.38,646.1c-6.45,8-17.43,10.57-27.11,10.56-17.72,0-30.15-15.88-30.34-31.9-.26-20.07,12.67-32.26,31.67-32.26,7,0,19,4.51,23.43,11.78a10.21,10.21,0,0,1,1.27,3.57l.72.06s0-.76-.09-1.22c-.18-2.93-1.22-6.64-1.65-10a28.35,28.35,0,0,1,0-7,12.3,12.3,0,0,1-2.45-.07c-2.43-.29-11.24-3.09-20.79-3.22-25.17-.33-41.69,13.78-42.24,38.31-.5,22.81,16.27,38.43,41.64,38.43a115.86,115.86,0,0,0,23-2.73s1.41-3.72,2.5-6.57a68.71,68.71,0,0,0,2.18-6.68Z",
    transform: "translate(-61.44 -336.09)"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M636,579.54h6.9V672H636Z",
    transform: "translate(-61.44 -336.09)"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M701.75,612.36c0-9.31,1.46-14.84,5-19.13,4.08-4.91,9.62-7.11,18.08-7.11,9,0,15,2.62,19,8.26,2.93,4.18,4.08,9.41,4.08,18V636.6c0,9.3-1.46,14.84-5,19.13-4.07,4.91-9.61,7.1-18.08,7.1-9,0-15.05-2.61-19-8.25-2.92-4.18-4.07-9.41-4.07-18Zm35.84.94c0-13.28-3.65-18.71-12.75-18.71S712.09,600,712.09,613.3v22.36c0,13.27,3.66,18.71,12.75,18.71s12.75-5.44,12.75-18.71Z",
    transform: "translate(-61.44 -336.09)"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M773.47,608.7V640c0,10.55,2.2,14.42,8,14.42,6.17,0,8.57-4.6,8.57-16.41V608.7h9.83v53.09H792.6l-.84-4.91c-3,4.39-6.27,6-12.22,6-7.32,0-12.33-3.13-14.43-9.09-1-2.72-1.46-6.69-1.46-12.64V608.7Z",
    transform: "translate(-61.44 -336.09)"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M812.93,616.75v-8h5.44l.52-16.2h9.3v16.2h9v8h-9v27.58c-.1,7.11,1.67,9.31,7.32,9.2h1.77v8.26H835c-13.69,0-16.61-3.24-16.61-18.29V616.75Z",
    transform: "translate(-61.44 -336.09)"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M860.12,587.17V643.6c-.11,7.63,1.77,10,7.73,10h1.88v8.15h-2.3c-13.9,0-17.14-3.66-17.14-19.13V587.17Z",
    transform: "translate(-61.44 -336.09)"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M889.89,641.2c0,9.3,3.24,13.59,10.13,13.59,5.12,0,7.74-2.2,9-7.42l8.47,1.77c-1.78,9.62-7.11,13.69-18.08,13.69-13.48,0-19.44-7.21-19.44-23.62v-7.63c0-16.72,5.75-23.82,19.12-23.82s19.13,7,19.13,23.82v5.86H889.89Zm18.91-11.08v-2c0-8.57-3-12.54-9.51-12.54s-9.4,4.07-9.4,12.54v2Z",
    transform: "translate(-61.44 -336.09)"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M929.41,616.75v-8h5.43l.52-16.2h9.31v16.2h9v8h-9v27.58c-.11,7.11,1.67,9.31,7.31,9.2h1.78v8.26h-2.3c-13.69,0-16.62-3.24-16.62-18.29V616.75Z",
    transform: "translate(-61.44 -336.09)"
  }));
};

const CartSVG = _ref => {
  let {
    fill,
    width,
    height,
    title
  } = _ref;
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: fill,
    width: width,
    height: height,
    viewBox: "0 0 31.42 24.76"
  }, /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14"
  }, /*#__PURE__*/React__default.createElement("circle", {
    cx: "12.39",
    cy: "22.19",
    r: "2.53"
  }), /*#__PURE__*/React__default.createElement("circle", {
    className: "cls-1",
    cx: "12.39",
    cy: "22.19",
    r: "2.07"
  })), /*#__PURE__*/React__default.createElement("g", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15"
  }, /*#__PURE__*/React__default.createElement("circle", {
    cx: "22.29",
    cy: "22.19",
    r: "2.53"
  }), /*#__PURE__*/React__default.createElement("circle", {
    className: "cls-2",
    cx: "22.29",
    cy: "22.19",
    r: "2.07"
  })), /*#__PURE__*/React__default.createElement("rect", {
    x: "5.5",
    y: "1.94",
    width: "25.91",
    height: "1.71"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "7.88",
    y: "15.23",
    width: "18.82",
    height: "1.7"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "-4.28",
    y: "7.6",
    width: "18",
    height: "1.73",
    transform: "translate(-0.81 16.42) rotate(-116.02)"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "7.27",
    y: "6.38",
    width: "22.61",
    height: "1.72"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "9.41",
    y: "10.84",
    width: "19.08",
    height: "1.7"
  }))));
};

const LinkIconSVG = _ref => {
  let {
    fill,
    width,
    height,
    title
  } = _ref;
  return /*#__PURE__*/React__default.createElement("svg", {
    id: "icon-link",
    viewBox: "0 0 32 32",
    width: width,
    height: height
  }, /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("path", {
    fill: fill,
    d: "M13.757 19.868c-0.416 0-0.832-0.159-1.149-0.476-2.973-2.973-2.973-7.81 0-10.783l6-6c1.44-1.44 3.355-2.233 5.392-2.233s3.951 0.793 5.392 2.233c2.973 2.973 2.973 7.81 0 10.783l-2.743 2.743c-0.635 0.635-1.663 0.635-2.298 0s-0.635-1.663 0-2.298l2.743-2.743c1.706-1.706 1.706-4.481 0-6.187-0.826-0.826-1.925-1.281-3.094-1.281s-2.267 0.455-3.094 1.281l-6 6c-1.706 1.706-1.706 4.481 0 6.187 0.635 0.635 0.635 1.663 0 2.298-0.317 0.317-0.733 0.476-1.149 0.476z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: fill,
    d: "M8 31.625c-2.037 0-3.952-0.793-5.392-2.233-2.973-2.973-2.973-7.81 0-10.783l2.743-2.743c0.635-0.635 1.664-0.635 2.298 0s0.635 1.663 0 2.298l-2.743 2.743c-1.706 1.706-1.706 4.481 0 6.187 0.826 0.826 1.925 1.281 3.094 1.281s2.267-0.455 3.094-1.281l6-6c1.706-1.706 1.706-4.481 0-6.187-0.635-0.635-0.635-1.663 0-2.298s1.663-0.635 2.298 0c2.973 2.973 2.973 7.81 0 10.783l-6 6c-1.44 1.44-3.355 2.233-5.392 2.233z"
  }));
};

const FlagUSASVG = _ref => {
  let {
    width,
    height
  } = _ref;
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    width: width,
    height: height
  }, /*#__PURE__*/React__default.createElement("rect", {
    style: {
      fill: "#F0F0F0"
    },
    width: "512",
    height: "512"
  }), /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("rect", {
    y: "64",
    style: {
      fill: "#D80027"
    },
    width: "512",
    height: "64"
  }), /*#__PURE__*/React__default.createElement("rect", {
    y: "192",
    style: {
      fill: "#D80027"
    },
    width: "512",
    height: "64"
  }), /*#__PURE__*/React__default.createElement("rect", {
    y: "320",
    style: {
      fill: "#D80027"
    },
    width: "512",
    height: "64"
  }), /*#__PURE__*/React__default.createElement("rect", {
    y: "448",
    style: {
      fill: "#D80027"
    },
    width: "512",
    height: "64"
  })), /*#__PURE__*/React__default.createElement("rect", {
    style: {
      fill: "#2E52B2"
    },
    width: "256",
    height: "275.69"
  }), /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "51.518,115.318 45.924,132.529 27.826,132.529 42.469,143.163 36.875,160.375    51.518,149.741 66.155,160.375 60.56,143.163 75.203,132.529 57.106,132.529  "
  }), /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "57.106,194.645 51.518,177.434 45.924,194.645 27.826,194.645 42.469,205.279    36.875,222.49 51.518,211.857 66.155,222.49 60.56,205.279 75.203,194.645  "
  }), /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "51.518,53.202 45.924,70.414 27.826,70.414 42.469,81.047 36.875,98.259 51.518,87.625    66.155,98.259 60.56,81.047 75.203,70.414 57.106,70.414  "
  }), /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "128.003,115.318 122.409,132.529 104.311,132.529 118.954,143.163 113.36,160.375    128.003,149.741 142.64,160.375 137.045,143.163 151.689,132.529 133.591,132.529  "
  }), /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "133.591,194.645 128.003,177.434 122.409,194.645 104.311,194.645 118.954,205.279    113.36,222.49 128.003,211.857 142.64,222.49 137.045,205.279 151.689,194.645  "
  }), /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "210.076,194.645 204.489,177.434 198.894,194.645 180.797,194.645 195.44,205.279    189.845,222.49 204.489,211.857 219.125,222.49 213.531,205.279 228.174,194.645  "
  }), /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "204.489,115.318 198.894,132.529 180.797,132.529 195.44,143.163 189.845,160.375    204.489,149.741 219.125,160.375 213.531,143.163 228.174,132.529 210.076,132.529  "
  }), /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "128.003,53.202 122.409,70.414 104.311,70.414 118.954,81.047 113.36,98.259    128.003,87.625 142.64,98.259 137.045,81.047 151.689,70.414 133.591,70.414  "
  }), /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "204.489,53.202 198.894,70.414 180.797,70.414 195.44,81.047 189.845,98.259    204.489,87.625 219.125,98.259 213.531,81.047 228.174,70.414 210.076,70.414  "
  })), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null));
};

const FlagUKSVG = _ref => {
  let {
    width,
    height
  } = _ref;
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    x: "0px",
    y: "0px",
    width: width,
    height: height,
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React__default.createElement("rect", {
    style: {
      fill: "#F0F0F0"
    },
    width: "512",
    height: "512"
  }), /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "0,304 208,304 208,512 304,512 304,304 512,304 512,208 304,208 304,0 208,0 208,208 0,208   "
  }), /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "406.92,333.913 512,438.993 512,333.913  "
  }), /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "333.913,333.913 512,512 512,461.64 384.273,333.913  "
  }), /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "464.564,512 333.913,381.336 333.913,512  "
  })), /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "333.913,333.913 512,512 512,461.64 384.273,333.913 "
  }), /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "333.913,333.913 512,512 512,461.64 384.273,333.913 "
  }), /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "80.302,333.913 0,414.215 0,333.913  "
  }), /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "178.084,356.559 178.084,511.997 22.658,511.997  "
  })), /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "127.724,333.916 0,461.641 0,512 0,512 178.084,333.916 "
  }), /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "105.08,178.087 0,73.007 0,178.087  "
  }), /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "178.087,178.087 0,0 0,50.36 127.727,178.087  "
  }), /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "47.436,0 178.087,130.663 178.087,0  "
  })), /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "178.087,178.087 0,0 0,50.36 127.727,178.087 "
  }), /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "178.087,178.087 0,0 0,50.36 127.727,178.087 "
  }), /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "431.698,178.087 512,97.785 512,178.087  "
  }), /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "333.916,155.441 333.916,0.003 489.342,0.003  "
  })), /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "384.276,178.084 512,50.359 512,0 512,0 333.916,178.084 "
  }), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null));
};

const FlagNetherlandsSVG = _ref => {
  let {
    width,
    height
  } = _ref;
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    width: width,
    height: height
  }, /*#__PURE__*/React__default.createElement("rect", {
    y: "0.006",
    style: {
      fill: "#F0F0F0"
    },
    width: "512",
    height: "511.989"
  }), /*#__PURE__*/React__default.createElement("rect", {
    style: {
      fill: "#A2001D"
    },
    width: "512",
    height: "170.663"
  }), /*#__PURE__*/React__default.createElement("rect", {
    y: "341.337",
    style: {
      fill: "#0052B4"
    },
    width: "512",
    height: "170.663"
  }), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null));
};

const FlagSwitzerlandSVG = _ref => {
  let {
    width,
    height
  } = _ref;
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    width: width,
    height: height
  }, /*#__PURE__*/React__default.createElement("rect", {
    style: {
      fill: "#D80027"
    },
    width: "512",
    height: "512"
  }), /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "395.13,209.624 302.377,209.624 302.377,116.87 209.623,116.87 209.623,209.624   116.87,209.624 116.87,302.377 209.623,302.377 209.623,395.13 302.377,395.13 302.377,302.377 395.13,302.377 "
  }), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null));
};

const FlagSwedenSVG = _ref => {
  let {
    width,
    height
  } = _ref;
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    width: width,
    height: height
  }, /*#__PURE__*/React__default.createElement("rect", {
    style: {
      fill: "#0052B4"
    },
    width: "512",
    height: "512"
  }), /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("rect", {
    x: "128",
    style: {
      fill: "#FFDA44"
    },
    width: "64",
    height: "512"
  }), /*#__PURE__*/React__default.createElement("rect", {
    y: "224",
    style: {
      fill: "#FFDA44"
    },
    width: "512",
    height: "64"
  })), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null));
};

const FlagSpainSVG = _ref => {
  let {
    width,
    height
  } = _ref;
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    width: width,
    height: height
  }, /*#__PURE__*/React__default.createElement("rect", {
    style: {
      fill: "#FFDA44"
    },
    width: "512",
    height: "512"
  }), /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("rect", {
    style: {
      fill: "#D80027"
    },
    width: "512",
    height: "170.663"
  }), /*#__PURE__*/React__default.createElement("rect", {
    y: "341.337",
    style: {
      fill: "#D80027"
    },
    width: "512",
    height: "170.663"
  })), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null));
};

const FlagPolandSVG = _ref => {
  let {
    width,
    height
  } = _ref;
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    width: width,
    height: height
  }, /*#__PURE__*/React__default.createElement("rect", {
    style: {
      fill: "#F0F0F0"
    },
    width: "512",
    height: "512"
  }), /*#__PURE__*/React__default.createElement("rect", {
    y: "256",
    style: {
      fill: "#D80027"
    },
    width: "512",
    height: "256"
  }), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null));
};

const FlagNorwaySVG = _ref => {
  let {
    width,
    height
  } = _ref;
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    width: width,
    height: height
  }, /*#__PURE__*/React__default.createElement("rect", {
    style: {
      fill: "#D80027"
    },
    width: "512",
    height: "512"
  }), /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "512,196.174 219.826,196.174 219.826,0 100.174,0 100.174,196.174 0,196.174 0,315.826   100.174,315.826 100.174,512 219.826,512 219.826,315.826 512,315.826 "
  }), /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "512,224 192,224 192,0 128,0 128,224 0,224 0,288 128,288 128,512 192,512 192,288 512,288   "
  }), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null));
};

const FlagKoreaSVG = _ref => {
  let {
    width,
    height
  } = _ref;
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    width: width,
    height: height
  }, /*#__PURE__*/React__default.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: "512",
    height: "512"
  }), /*#__PURE__*/React__default.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M350.445,256c0,23.611-42.285,82.639-94.445,82.639S161.555,279.611,161.555,256  c0-52.161,42.285-94.445,94.445-94.445S350.445,203.839,350.445,256z"
  }), /*#__PURE__*/React__default.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M350.445,256c0,52.161-42.285,94.445-94.445,94.445S161.555,308.161,161.555,256"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "359.346",
    y: "323.512",
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -126.6671 364.829)",
    width: "35.417",
    height: "23.607"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "317.608",
    y: "365.247",
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -168.4038 347.5395)",
    width: "35.416",
    height: "23.607"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "409.434",
    y: "373.576",
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -147.3977 414.9103)",
    width: "35.417",
    height: "23.607"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "367.696",
    y: "415.334",
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -189.1502 397.6272)",
    width: "35.416",
    height: "23.607"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "384.391",
    y: "348.543",
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -137.032 389.8698)",
    width: "35.416",
    height: "23.607"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "342.652",
    y: "390.291",
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -178.777 372.5833)",
    width: "35.416",
    height: "23.607"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "333.994",
    y: "118.967",
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 558.3055 492.7982)",
    width: "94.441",
    height: "23.607"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "317.609",
    y: "123.137",
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 477.0044 467.464)",
    width: "35.417",
    height: "23.607"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "359.337",
    y: "164.879",
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 518.7222 568.2271)",
    width: "35.416",
    height: "23.607"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "367.672",
    y: "73.062",
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 597.8773 417.3795)",
    width: "35.417",
    height: "23.607"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "409.423",
    y: "114.792",
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 639.6409 518.1393)",
    width: "35.416",
    height: "23.607"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "58.512",
    y: "394.466",
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 318.2447 44.2295)",
    width: "94.441",
    height: "23.607"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "133.929",
    y: "390.285",
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 328.7331 10.545)",
    width: "35.417",
    height: "23.607"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "92.197",
    y: "348.548",
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 286.9978 27.8293)",
    width: "35.418",
    height: "23.607"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "108.603",
    y: "344.383",
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 297.5015 -5.8596)",
    width: "94.441",
    height: "23.607"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "58.513",
    y: "93.932",
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 255.2646 105.7379)",
    width: "94.441",
    height: "23.607"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "83.553",
    y: "118.979",
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 315.7209 130.7894)",
    width: "94.441",
    height: "23.607"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "108.596",
    y: "144.022",
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 376.1802 155.8332)",
    width: "94.441",
    height: "23.607"
  }), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null));
};

const FlagJapanSVG = _ref => {
  let {
    width,
    height
  } = _ref;
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    width: width,
    height: height
  }, /*#__PURE__*/React__default.createElement("rect", {
    style: {
      fill: "#F0F0F0"
    },
    width: "512",
    height: "512"
  }), /*#__PURE__*/React__default.createElement("circle", {
    style: {
      fill: "#D80027"
    },
    cx: "256",
    cy: "256",
    r: "128"
  }), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null));
};

const FlagItalySVG = _ref => {
  let {
    width,
    height
  } = _ref;
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    height: height,
    width: width
  }, /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "341.334,0 170.666,0 0,0 0,512 170.666,512 341.334,512 512,512 512,0 "
  }), /*#__PURE__*/React__default.createElement("rect", {
    style: {
      fill: "#6DA544"
    },
    width: "170.663",
    height: "512"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "341.337",
    style: {
      fill: "#D80027"
    },
    width: "170.663",
    height: "512"
  }), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null));
};

const FlagIrelandSVG = _ref => {
  let {
    width,
    height
  } = _ref;
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    width: width,
    height: height
  }, /*#__PURE__*/React__default.createElement("rect", {
    y: "0.006",
    style: {
      fill: "#F0F0F0"
    },
    width: "512",
    height: "511.989"
  }), /*#__PURE__*/React__default.createElement("rect", {
    style: {
      fill: "#6DA544"
    },
    width: "170.663",
    height: "512"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "341.337",
    style: {
      fill: "#FF9811"
    },
    width: "170.663",
    height: "512"
  }), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null));
};

const FlagHungarySVG = _ref => {
  let {
    width,
    height
  } = _ref;
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    width: width,
    height: height
  }, /*#__PURE__*/React__default.createElement("rect", {
    y: "0.006",
    style: {
      fill: "#F0F0F0"
    },
    width: "512",
    height: "511.989"
  }), /*#__PURE__*/React__default.createElement("rect", {
    style: {
      fill: "#D80027"
    },
    width: "512",
    height: "170.663"
  }), /*#__PURE__*/React__default.createElement("rect", {
    y: "341.337",
    style: {
      fill: "#6DA544"
    },
    width: "512",
    height: "170.663"
  }), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null));
};

const FlagGermanySVG = _ref => {
  let {
    width,
    height
  } = _ref;
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    width: width,
    height: height
  }, /*#__PURE__*/React__default.createElement("rect", {
    style: {
      fill: "#D80027"
    },
    width: "512",
    height: "512"
  }), /*#__PURE__*/React__default.createElement("rect", {
    width: "512",
    height: "170.663"
  }), /*#__PURE__*/React__default.createElement("rect", {
    y: "341.337",
    style: {
      fill: "#FFDA44"
    },
    width: "512",
    height: "170.663"
  }), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null));
};

const FlagFranceSVG = _ref => {
  let {
    width,
    height
  } = _ref;
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    width: width,
    height: height
  }, /*#__PURE__*/React__default.createElement("rect", {
    style: {
      fill: "#F0F0F0"
    },
    width: "512",
    height: "512"
  }), /*#__PURE__*/React__default.createElement("rect", {
    style: {
      fill: "#0052B4"
    },
    width: "170.663",
    height: "512"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "341.337",
    style: {
      fill: "#D80027"
    },
    width: "170.663",
    height: "512"
  }), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null));
};

const FlagFinlandSVG = _ref => {
  let {
    width,
    height
  } = _ref;
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    width: width,
    height: height
  }, /*#__PURE__*/React__default.createElement("rect", {
    style: {
      fill: "#F0F0F0"
    },
    width: "512",
    height: "512"
  }), /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "512,224 192,224 192,0 128,0 128,224 0,224 0,288 128,288 128,512 192,512 192,288 512,288   "
  }), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null));
};

const FlagEUSVG = _ref => {
  let {
    width,
    height
  } = _ref;
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    width: width,
    height: height
  }, /*#__PURE__*/React__default.createElement("rect", {
    style: {
      fill: "#0052B4"
    },
    width: "512",
    height: "512"
  }), /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "256,105.739 263.993,130.337 289.855,130.337 268.931,145.539 276.924,170.136 256,154.935    235.076,170.136 243.069,145.539 222.145,130.337 248.007,130.337  "
  }), /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "149.749,149.75 172.794,161.49 191.083,143.204 187.036,168.749 210.081,180.49    184.536,184.536 180.49,210.081 168.747,187.036 143.204,191.083 161.491,172.794  "
  }), /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "105.739,256 130.336,248.007 130.337,222.145 145.539,243.069 170.136,235.076 154.935,256    170.136,276.924 145.539,268.932 130.337,289.855 130.337,263.993  "
  }), /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "149.749,362.251 161.49,339.206 143.204,320.917 168.749,324.964 180.489,301.92    184.536,327.464 210.08,331.51 187.037,343.253 191.083,368.797 172.794,350.509  "
  }), /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "256,406.261 248.007,381.664 222.145,381.663 243.069,366.461 235.076,341.865 256,357.065    276.924,341.865 268.931,366.461 289.855,381.663 263.992,381.663  "
  }), /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "362.25,362.251 339.206,350.51 320.917,368.797 324.964,343.251 301.92,331.511    327.464,327.464 331.511,301.92 343.251,324.964 368.796,320.917 350.509,339.207  "
  }), /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "406.261,256 381.663,263.993 381.663,289.855 366.461,268.931 341.865,276.924 357.065,256    341.865,235.076 366.462,243.069 381.663,222.145 381.663,248.008  "
  }), /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "362.25,149.75 350.51,172.794 368.797,191.083 343.251,187.036 331.511,210.08    327.464,184.536 301.92,180.489 324.964,168.749 320.917,143.205 339.207,161.491  "
  })), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null));
};

const FlagDenmarkSVG = _ref => {
  let {
    width,
    height
  } = _ref;
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    width: width,
    height: height
  }, /*#__PURE__*/React__default.createElement("rect", {
    style: {
      fill: "#D80027"
    },
    width: "512",
    height: "512"
  }), /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("rect", {
    x: "128",
    style: {
      fill: "#F0F0F0"
    },
    width: "64",
    height: "512"
  }), /*#__PURE__*/React__default.createElement("rect", {
    y: "224",
    style: {
      fill: "#F0F0F0"
    },
    width: "512",
    height: "64"
  })), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null));
};

const FlagCzechSVG = _ref => {
  let {
    width,
    height
  } = _ref;
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    width: width,
    height: height
  }, /*#__PURE__*/React__default.createElement("rect", {
    style: {
      fill: "#D80027"
    },
    width: "512",
    height: "512"
  }), /*#__PURE__*/React__default.createElement("rect", {
    style: {
      fill: "#F0F0F0"
    },
    width: "512",
    height: "256"
  }), /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "0,512 256,256 0,0 "
  }), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null));
};

const FlagChinaSVG = _ref => {
  let {
    width,
    height
  } = _ref;
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    width: width,
    height: height
  }, /*#__PURE__*/React__default.createElement("rect", {
    style: {
      fill: "#D80027"
    },
    width: "512",
    height: "512"
  }), /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "167.619,167.43 187.16,227.573 250.399,227.573 199.238,264.744 218.78,324.887    167.619,287.717 116.457,324.887 135.999,264.744 84.837,227.573 148.076,227.573  "
  }), /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "290.787,367.465 271.6,353.525 252.416,367.464 259.743,344.911 240.558,330.971    264.274,330.971 271.6,308.418 278.931,330.971 302.644,330.971 283.459,344.91  "
  }), /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "340.837,298.576 317.123,298.576 309.794,321.13 302.467,298.577 278.751,298.576    297.938,284.636 290.609,262.084 309.796,276.021 328.981,262.083 321.652,284.636  "
  }), /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "340.837,213.426 321.652,227.366 328.98,249.917 309.796,235.981 290.609,249.919    297.938,227.364 278.752,213.426 302.467,213.425 309.796,190.87 317.123,213.425  "
  }), /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "290.787,144.536 283.46,167.091 302.644,181.029 278.932,181.03 271.602,203.586    264.274,181.029 240.56,181.031 259.745,167.09 252.416,144.535 271.6,158.476  "
  })), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null));
};

const FlagCanadaSVG = _ref => {
  let {
    width,
    height
  } = _ref;
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    width: width,
    height: height
  }, /*#__PURE__*/React__default.createElement("rect", {
    y: "0",
    style: {
      fill: "#F0F0F0"
    },
    width: "512",
    height: "512"
  }), /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("rect", {
    y: "0",
    style: {
      fill: "#D80027"
    },
    width: "117.7",
    height: "512"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "394.3",
    y: "0",
    style: {
      fill: "#D80027"
    },
    width: "117.7",
    height: "512"
  }), /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "313.4,295.6 370.9,266.9 342.2,252.5 342.2,223.8 284.7,252.5 313.4,195.1 284.7,195.1 256,152    227.3,195.1 198.6,195.1 227.3,252.5 169.8,223.8 169.8,252.5 141.1,266.9 198.6,295.6 184.2,324.3 241.6,324.3 241.6,367.4    270.4,367.4 270.4,324.3 327.8,324.3  "
  })));
};

const FlagBelgiumSVG = _ref => {
  let {
    width,
    height
  } = _ref;
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    width: width,
    height: height
  }, /*#__PURE__*/React__default.createElement("rect", {
    y: "0.006",
    style: {
      fill: "#FFDA44"
    },
    width: "512",
    height: "511.989"
  }), /*#__PURE__*/React__default.createElement("rect", {
    width: "170.663",
    height: "512"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "341.337",
    style: {
      fill: "#D80027"
    },
    width: "170.663",
    height: "512"
  }), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null));
};

const FlagAustriaSVG = _ref => {
  let {
    width,
    height
  } = _ref;
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    width: width,
    height: height
  }, /*#__PURE__*/React__default.createElement("rect", {
    style: {
      fill: "#F0F0F0"
    },
    width: "512",
    height: "512"
  }), /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("rect", {
    style: {
      fill: "#D80027"
    },
    width: "512",
    height: "170.663"
  }), /*#__PURE__*/React__default.createElement("rect", {
    y: "341.337",
    style: {
      fill: "#D80027"
    },
    width: "512",
    height: "170.663"
  })), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null));
};

const FlagAustraliaSVG = _ref => {
  let {
    width,
    height
  } = _ref;
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    width: width,
    height: height
  }, /*#__PURE__*/React__default.createElement("rect", {
    style: {
      fill: "#0052B4"
    },
    width: "512",
    height: "512"
  }), /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "128,307.482 141.697,336.124 172.63,328.974 158.778,357.542 183.652,377.268    152.682,384.248 152.767,415.997 128,396.134 103.233,415.997 103.319,384.248 72.348,377.268 97.223,357.542 83.37,328.974    114.303,336.124  "
  }), /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "387.844,343.989 394.378,357.65 409.131,354.241 402.524,367.865 414.389,377.275    399.617,380.604 399.658,395.747 387.844,386.273 376.032,395.747 376.073,380.604 361.301,377.275 373.166,367.865    366.557,354.241 381.312,357.65  "
  }), /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "327.066,199.066 333.599,212.728 348.353,209.317 341.747,222.943 353.611,232.352    338.838,235.681 338.878,250.824 327.066,241.35 315.253,250.824 315.294,235.681 300.522,232.352 312.386,222.943    305.779,209.317 320.532,212.728  "
  }), /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "387.844,116.253 394.378,129.914 409.131,126.504 402.525,140.13 414.389,149.538    399.617,152.869 399.658,168.011 387.844,158.537 376.032,168.011 376.073,152.869 361.301,149.538 373.165,140.13    366.557,126.504 381.312,129.914  "
  }), /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "440.934,178.363 447.468,192.024 462.221,188.614 455.614,202.24 467.478,211.649    452.706,214.978 452.747,230.121 440.934,220.646 429.122,230.121 429.162,214.978 414.389,211.649 426.253,202.24    419.646,188.614 434.401,192.024  "
  }), /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "402.973,250.824 408.112,266.641 424.742,266.641 411.287,276.415 416.426,292.231    402.973,282.456 389.518,292.231 394.657,276.415 381.204,266.641 397.833,266.641  "
  }), /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "256,0 256,48.896 215.853,89.043 256,89.043 256,166.957 203.464,166.957 256,219.492    256,256 232.281,256 166.957,190.664 166.957,256 89.043,256 89.043,178.276 11.331,256 0,256 0,207.104 40.147,166.957 0,166.957    0,89.043 52.536,89.043 0,36.508 0,0 23.719,0 89.043,65.336 89.043,0 166.957,0 166.957,77.724 244.669,0  "
  })), /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "0,152.001 103.999,152.001 104.001,256 152.001,256 152.001,152.001 256,152.001   256,104.001 151.999,104.001 152.001,0 104.001,0 104.001,104.001 0,104.001 "
  }), /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "166.957,166.957 256,256 256,230.82 192.137,166.957 "
  }), /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "166.957,166.957 256,256 256,230.82 192.137,166.957 "
  }), /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "166.957,166.957 256,256 256,230.82 192.137,166.957  "
  }), /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "63.862,166.959 0,230.821 0,256 0,256 89.041,166.959  "
  })), /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "89.043,89.043 0,0 0,25.18 63.863,89.043 "
  }), /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "89.043,89.043 0,0 0,25.18 63.863,89.043 "
  }), /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "89.043,89.043 0,0 0,25.18 63.863,89.043  "
  }), /*#__PURE__*/React__default.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "192.138,89.041 256,25.179 256,0 256,0 166.959,89.041  "
  })), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", null));
};

const FlagIconList = {
  "flag-us": FlagUSASVG,
  "flag-gb": FlagUKSVG,
  "flag-nl": FlagNetherlandsSVG,
  "flag-ch": FlagSwitzerlandSVG,
  "flag-se": FlagSwedenSVG,
  "flag-es": FlagSpainSVG,
  "flag-pl": FlagPolandSVG,
  "flag-no": FlagNorwaySVG,
  "flag-kr": FlagKoreaSVG,
  "flag-jp": FlagJapanSVG,
  "flag-it": FlagItalySVG,
  "flag-ie": FlagIrelandSVG,
  "flag-hu": FlagHungarySVG,
  "flag-de": FlagGermanySVG,
  "flag-fr": FlagFranceSVG,
  "flag-fi": FlagFinlandSVG,
  "flag-eu": FlagEUSVG,
  "flag-dk": FlagDenmarkSVG,
  "flag-cz": FlagCzechSVG,
  "flag-cn": FlagChinaSVG,
  "flag-ca": FlagCanadaSVG,
  "flag-be": FlagBelgiumSVG,
  "flag-at": FlagAustriaSVG,
  "flag-au": FlagAustraliaSVG
};

const GPayIcon = _ref => {
  let {
    fill,
    width,
    height,
    title
  } = _ref;
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    version: "1.1",
    viewBox: "0 0 1000 540",
    xmlSpace: "preserve",
    fill: fill,
    width: width,
    height: height
  }, /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("path", {
    fill: "#FFF",
    d: "M722.7 170h-352c-110 0-200 90-200 200s90 200 200 200h352c110 0 200-90 200-200s-90-200-200-200z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#3C4043",
    d: "M722.7 186.2c24.7 0 48.7 4.9 71.3 14.5 21.9 9.3 41.5 22.6 58.5 39.5 16.9 16.9 30.2 36.6 39.5 58.5 9.6 22.6 14.5 46.6 14.5 71.3s-4.9 48.7-14.5 71.3c-9.3 21.9-22.6 41.5-39.5 58.5-16.9 16.9-36.6 30.2-58.5 39.5-22.6 9.6-46.6 14.5-71.3 14.5h-352c-24.7 0-48.7-4.9-71.3-14.5-21.9-9.3-41.5-22.6-58.5-39.5-16.9-16.9-30.2-36.6-39.5-58.5-9.6-22.6-14.5-46.6-14.5-71.3s4.9-48.7 14.5-71.3c9.3-21.9 22.6-41.5 39.5-58.5 16.9-16.9 36.6-30.2 58.5-39.5 22.6-9.6 46.6-14.5 71.3-14.5h352m0-16.2h-352c-110 0-200 90-200 200s90 200 200 200h352c110 0 200-90 200-200s-90-200-200-200z"
  }), /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("g", {
    fill: "#3C4043"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M529.3 384.2v60.5h-19.2V295.3H561c12.9 0 23.9 4.3 32.9 12.9 9.2 8.6 13.8 19.1 13.8 31.5 0 12.7-4.6 23.2-13.8 31.7-8.9 8.5-19.9 12.7-32.9 12.7h-31.7v.1zm0-70.5v52.1h32.1c7.6 0 14-2.6 19-7.7 5.1-5.1 7.7-11.3 7.7-18.3 0-6.9-2.6-13-7.7-18.1-5-5.3-11.3-7.9-19-7.9h-32.1v-.1z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M657.9 339.1c14.2 0 25.4 3.8 33.6 11.4 8.2 7.6 12.3 18 12.3 31.2v63h-18.3v-14.2h-.8c-7.9 11.7-18.5 17.5-31.7 17.5-11.3 0-20.7-3.3-28.3-10s-11.4-15-11.4-25c0-10.6 4-19 12-25.2 8-6.3 18.7-9.4 32-9.4 11.4 0 20.8 2.1 28.1 6.3v-4.4c0-6.7-2.6-12.3-7.9-17-5.3-4.7-11.5-7-18.6-7-10.7 0-19.2 4.5-25.4 13.6l-16.9-10.6c9.3-13.5 23.1-20.2 41.3-20.2zm-24.8 74.2c0 5 2.1 9.2 6.4 12.5 4.2 3.3 9.2 5 14.9 5 8.1 0 15.3-3 21.6-9s9.5-13 9.5-21.1c-6-4.7-14.3-7.1-25-7.1-7.8 0-14.3 1.9-19.5 5.6-5.3 3.9-7.9 8.6-7.9 14.1z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M808.2 342.4l-64 147.2h-19.8l23.8-51.5-42.2-95.7h20.9l30.4 73.4h.4l29.6-73.4h20.9z"
  })), /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
    fill: "#4285F4",
    d: "M452.93 372c0-6.26-.56-12.25-1.6-18.01h-80.48v33l46.35.01c-1.88 10.98-7.93 20.34-17.2 26.58v21.41h27.59c16.11-14.91 25.34-36.95 25.34-62.99z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#34A853",
    d: "M400.01 413.58c-7.68 5.18-17.57 8.21-29.14 8.21-22.35 0-41.31-15.06-48.1-35.36h-28.46v22.08c14.1 27.98 43.08 47.18 76.56 47.18 23.14 0 42.58-7.61 56.73-20.71l-27.59-21.4z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#FABB05",
    d: "M320.09 370.05c0-5.7.95-11.21 2.68-16.39v-22.08h-28.46c-5.83 11.57-9.11 24.63-9.11 38.47s3.29 26.9 9.11 38.47l28.46-22.08a51.657 51.657 0 01-2.68-16.39z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#E94235",
    d: "M370.87 318.3c12.63 0 23.94 4.35 32.87 12.85l24.45-24.43c-14.85-13.83-34.21-22.32-57.32-22.32-33.47 0-62.46 19.2-76.56 47.18l28.46 22.08c6.79-20.3 25.75-35.36 48.1-35.36z"
  }))));
};

const Icon$1 = _ref => {
  let {
    fill,
    width,
    height,
    title
  } = _ref;
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    version: "1.1",
    viewBox: "0 0 165.521 105.965",
    xmlSpace: "preserve",
    fill: fill,
    width: width,
    height: height
  }, /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("path", {
    d: "M150.698 0H14.823c-.566 0-1.133 0-1.698.003-.477.004-.953.009-1.43.022-1.039.028-2.087.09-3.113.274a10.51 10.51 0 00-2.958.975 9.932 9.932 0 00-4.35 4.35 10.463 10.463 0 00-.975 2.96C.113 9.611.052 10.658.024 11.696c-.013.477-.019.953-.022 1.43C0 13.69 0 14.256 0 14.823v76.318c0 .567 0 1.132.002 1.699.003.476.009.953.022 1.43.028 1.036.09 2.084.275 3.11a10.46 10.46 0 00.974 2.96 9.897 9.897 0 001.83 2.52 9.874 9.874 0 002.52 1.83c.947.483 1.917.79 2.96.977 1.025.183 2.073.245 3.112.273.477.011.953.018 1.43.02.565.004 1.132.004 1.698.004h135.875c.565 0 1.132 0 1.697-.004a79.71 79.71 0 001.431-.02c1.037-.028 2.085-.09 3.113-.273a10.478 10.478 0 002.958-.977 9.955 9.955 0 004.35-4.35c.483-.947.789-1.917.974-2.96.186-1.026.246-2.074.274-3.11.013-.477.02-.954.022-1.43.004-.567.004-1.132.004-1.699V14.824c0-.567 0-1.133-.004-1.699a63.067 63.067 0 00-.022-1.429c-.028-1.038-.088-2.085-.274-3.112a10.4 10.4 0 00-.974-2.96 9.941 9.941 0 00-4.35-4.35A10.52 10.52 0 00156.939.3c-1.028-.185-2.076-.246-3.113-.274a71.413 71.413 0 00-1.431-.022C151.83 0 151.263 0 150.698 0z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "#FFF",
    d: "M150.698 3.532l1.672.003c.452.003.905.008 1.36.02.792.022 1.719.065 2.583.22.75.135 1.38.34 1.984.648a6.392 6.392 0 012.804 2.807c.306.6.51 1.226.645 1.983.154.854.197 1.783.218 2.58.013.45.019.9.02 1.36.005.557.005 1.113.005 1.671v76.318c0 .558 0 1.114-.004 1.682-.002.45-.008.9-.02 1.35-.022.796-.065 1.725-.221 2.589a6.855 6.855 0 01-.645 1.975 6.397 6.397 0 01-2.808 2.807c-.6.306-1.228.512-1.971.645-.882.157-1.847.2-2.574.22-.457.01-.912.017-1.379.019-.555.004-1.113.004-1.669.004H14.801c-.55 0-1.1 0-1.66-.004a75.086 75.086 0 01-1.35-.018c-.744-.02-1.71-.064-2.584-.22a6.938 6.938 0 01-1.986-.65 6.337 6.337 0 01-1.622-1.18 6.355 6.355 0 01-1.178-1.623 6.935 6.935 0 01-.647-1.985c-.155-.863-.198-1.788-.22-2.578a66.017 66.017 0 01-.02-1.355l-.002-1.327V14.474l.002-1.325c.003-.453.008-.905.02-1.357.022-.792.065-1.717.222-2.587a6.924 6.924 0 01.646-1.981c.304-.598.7-1.144 1.18-1.622a6.385 6.385 0 011.624-1.18 6.96 6.96 0 011.98-.647c.865-.155 1.792-.198 2.586-.22.452-.012.905-.017 1.354-.02l1.677-.003h135.875"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M45.186 35.64c1.417-1.772 2.38-4.152 2.126-6.585-2.075.104-4.607 1.37-6.073 3.143-1.316 1.52-2.48 4-2.177 6.33 2.33.202 4.656-1.165 6.124-2.887M47.285 38.983c-3.382-.202-6.258 1.919-7.873 1.919-1.616 0-4.09-1.818-6.764-1.769-3.482.051-6.713 2.02-8.48 5.15-3.634 6.264-.959 15.556 2.575 20.657 1.717 2.524 3.785 5.303 6.51 5.203 2.575-.101 3.584-1.668 6.714-1.668 3.128 0 4.037 1.668 6.763 1.617 2.827-.05 4.594-2.525 6.31-5.051 1.969-2.877 2.775-5.655 2.825-5.808-.05-.05-5.45-2.122-5.5-8.333-.051-5.201 4.24-7.675 4.441-7.828-2.423-3.584-6.209-3.988-7.52-4.09"
  }), /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
    d: "M76.734 31.944c7.35 0 12.47 5.067 12.47 12.444 0 7.404-5.225 12.497-12.654 12.497h-8.14v12.943h-5.88V31.944h14.204zM68.41 51.949h6.747c5.12 0 8.034-2.756 8.034-7.534 0-4.778-2.914-7.509-8.008-7.509h-6.773V51.95zM90.74 61.979c0-4.831 3.702-7.798 10.266-8.166l7.56-.446v-2.126c0-3.072-2.074-4.91-5.539-4.91-3.282 0-5.33 1.575-5.828 4.043h-5.356c.315-4.988 4.568-8.664 11.394-8.664 6.695 0 10.974 3.545 10.974 9.084v19.034h-5.435v-4.542h-.13c-1.602 3.072-5.094 5.015-8.717 5.015-5.408 0-9.189-3.36-9.189-8.322zm17.826-2.494v-2.18l-6.8.42c-3.386.237-5.303 1.733-5.303 4.096 0 2.415 1.996 3.99 5.041 3.99 3.964 0 7.062-2.73 7.062-6.326zM119.342 79.989v-4.595c.419.105 1.364.105 1.837.105 2.625 0 4.043-1.102 4.909-3.938 0-.052.5-1.68.5-1.706l-9.977-27.646h6.143l6.984 22.474h.104l6.985-22.474h5.985l-10.344 29.063c-2.362 6.695-5.093 8.848-10.816 8.848-.473 0-1.891-.053-2.31-.131z"
  })));
};

const PayPalIcon = _ref => {
  let {
    width,
    height
  } = _ref;
  return /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: `${width}px`,
      height: `${height}px`,
      display: "inline-block"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    align: "center"
  })), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    align: "center"
  }, /*#__PURE__*/React__default.createElement("a", {
    href: "https://www.paypal.com/c2/webapps/mpp/home?locale.x=en_C2",
    title: "PayPal",
    onClick: () => window.open('https://www.paypal.com/c2/webapps/mpp/home?locale.x=en_C2', 'WIPaypal', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=1060, height=700')
  }, /*#__PURE__*/React__default.createElement("img", {
    src: "https://www.paypalobjects.com/digitalassets/c/website/marketing/apac/C2/logos-buttons/optimize/Online_Primary_Acceptance_Mark_RGB_V2.jpg",
    alt: "PayPal acceptance mark"
  }))))));
};
PayPalIcon.propTypes = {
  width: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired
};

const VisaIcon = _ref => {
  let {
    width,
    height,
    fill,
    title
  } = _ref;
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 950 500",
    fill: fill,
    width: width,
    height: height
  }, /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("path", {
    fill: "#1434CB",
    d: "M1461.26 739.84l-251.37 599.74h-164l-123.7-478.62c-7.51-29.48-14.04-40.28-36.88-52.7-37.29-20.23-98.87-39.21-153.05-50.99l3.68-17.43h263.99c33.65 0 63.9 22.4 71.54 61.15l65.33 347.04 161.46-408.2h163v.01zm642.58 403.93c.66-158.29-218.88-167.01-217.37-237.72.47-21.52 20.96-44.4 65.81-50.24 22.23-2.91 83.48-5.13 152.95 26.84l27.25-127.18c-37.33-13.55-85.36-26.59-145.12-26.59-153.35 0-261.27 81.52-262.18 198.25-.99 86.34 77.03 134.52 135.81 163.21 60.47 29.38 80.76 48.26 80.53 74.54-.43 40.23-48.23 57.99-92.9 58.69-77.98 1.2-123.23-21.1-159.3-37.87l-28.12 131.39c36.25 16.63 103.16 31.14 172.53 31.87 162.99 0 269.61-80.51 270.11-205.19zm404.94 195.81h143.49l-125.25-599.74h-132.44c-29.78 0-54.9 17.34-66.02 44l-232.81 555.74h162.91L2291 1250h199.05l18.73 89.58zm-173.11-212.5l81.66-225.18 47 225.18h-128.66zm-652.74-387.24l-128.29 599.74H1399.5l128.34-599.74h155.09z",
    transform: "translate(0 69.671) scale(.30255)"
  }));
};

const SVGComponent = _ref => {
  let {
    width,
    height,
    fill,
    title
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1400 1400",
    style: {
      enableBackground: "new 0 0 1600 1600"
    },
    xmlSpace: "preserve",
    fill: fill,
    width: width,
    height: height
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#006FCF;}\n"), /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1398.005127,1401.0050049 788.5100098,1401.0050049 198,1401.0050049 198,791.2319946 198,201  797.9819946,201 1398.005127,201 1398.005127,798.8800049 1398.005127,1401.0050049  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M956.2340088,1037.0849609L932.0889893,1007.375v29.7099609h-78.9909668v-50.7059326 c-10.2080078,4.7019043-21.3950195,7.1309204-33.1940308,7.1309204h-27.9119873v43.5750122H672.7769775l-21.822998-28.5500488 l-21.7009888,28.5500488H431.4190369V848.6469116h198.7500305l21.7069092,28.2980347l21.7090454-28.2980347h724.420105V201H198 v506.0829468l45.2059937-105.5599976h77.6759949l25.2200012,58.8920288v-58.8920288h97.2170105l15.0109863,42.69104 l14.9150085-42.69104h434.0800781v21.8070068c15.7958984-13.875,37.1219482-21.8070068,62.3019409-21.8070068h138.1780396 l25.2199707,58.8950806v-58.8950806h81.8299561l21.6400146,33.5410156v-33.5410156h81.7398682v188.4430542h-81.2698975 l-21.8099365-34.052063v34.052063h-118.6999512l-11.7600098-28.8840942h-32.5200195l-11.5700684,28.8840942H966.882019 c-24.1360474,0-44.4330444-7.3030396-59.5569458-20.3690796v20.3690796H785.4850464l-24.1449585-29.7120361v29.7120361 H309.5270081l-11.7579956-28.8840942h-32.5250549l-11.5619507,28.8840942H198v611.0390015h1200.005127v-377.8100586 c-12.130127,8.8300781-27.710083,13.8900146-45.6101074,13.8900146H956.2340088L956.2340088,1037.0849609z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1384.7250977,903.8839722l14.1098633-31.7109985h-74.6599121 c-30.7700195,0-48.9899902,18.7839966-48.9899902,44.4359741c0,26.6629639,17.2399902,42.0130005,44.0898438,42.0130005 h33.5102539c7.4398193,0,12.7398682,4.6470337,12.7398682,11.7150269c0,7.0690308-5.3000488,11.5139771-12.7398682,11.5139771 h-73.2901611v31.7139893h72.9000244c30.7600098,0,48.9899902-18.5839233,48.9899902-45.8540039 c0-25.6519775-16.0700684-40.5980225-44.0998535-40.5980225h-33.5001221c-7.4500732,0-12.7399902-4.6469116-12.7399902-11.71698 c0-7.0669556,5.289917-11.5119629,12.7399902-11.5119629H1384.7250977L1384.7250977,903.8839722z M1181.5250244,915.3959351 c0-7.0669556,5.2800293-11.5119629,12.7299805-11.5119629h60.9499512l14.1099854-31.7109985h-74.6599121 c-30.7700195,0-48.9899902,18.7839966-48.9899902,44.4359741c0,26.6629639,17.2399902,42.0130005,44.0800781,42.0130005 h33.5198975c7.4400635,0,12.7299805,4.6470337,12.7299805,11.7150269c0,7.0690308-5.289917,11.5139771-12.7299805,11.5139771 h-73.3000488v31.7139893H1222.875c30.7600098,0,48.9799805-18.5839233,48.9799805-45.8540039 c0-25.6519775-16.0699463-40.5980225-44.0899658-40.5980225h-33.5100098 C1186.8050537,927.112915,1181.5250244,922.4660034,1181.5250244,915.3959351L1181.5250244,915.3959351z  M1018.6850586,1013.5649414h115.2299805v-31.7139893h-79.3699951v-24.0369263h77.4099121v-30.9030762h-77.4099121v-23.0269775 h79.3699951v-31.7109985h-115.2299805V1013.5649414L1018.6850586,1013.5649414z M1013.0050049,1013.5649414 l-45.8469238-51.5079956c23.1209717-4.8500366,37.0369873-22.2189941,37.0369873-44.2349243 c0-27.0670166-18.8170166-45.6490479-48.9899902-45.6490479H876.625v141.3919678h35.8590088v-50.0939331h13.9129639 l42.3290405,50.0939331H1013.0050049L1013.0050049,1013.5649414z M951.4799805,932.7680054h-38.9959717v-28.8840332h38.9959717 c10.9730225,0,16.6580811,6.6659546,16.6580811,14.5420532 C968.1380615,926.5059814,962.4530029,932.7680054,951.4799805,932.7680054L951.4799805,932.7680054z M861.1550293,919.8399658 c0-28.2770386-18.8149414-47.6669922-48.9880371-47.6669922h-79.5599365v141.3919678h35.8589478v-46.0560303h42.5239868 C841.947998,967.5089111,861.1550293,947.1099243,861.1550293,919.8399658L861.1550293,919.8399658z M825.0999756,920.0430298 c0,8.6849976-5.6859741,15.7548828-16.6578979,15.7548828h-39.9760742v-31.9139404h39.9760742 C819.4140015,903.8839722,825.0999756,911.1569824,825.0999756,920.0430298L825.0999756,920.0430298z M729.4760132,1013.5649414 l-56.8279419-71.3040161l56.4349365-70.0879517h-43.8929443l-33.3140869,43.4249878l-33.3109741-43.4249878h-45.0700073 l56.6309814,70.8970337l-56.4349976,70.4949341h43.894043l33.3130493-43.8320312l33.506958,43.8320312H729.4760132 L729.4760132,1013.5649414z M455.5360107,1013.5649414h115.223999v-31.7139893h-79.3649902v-24.0369263h77.4039917v-30.9030762 h-77.4039917v-23.0269775h79.3649902v-31.7109985h-115.223999V1013.5649414L455.5360107,1013.5649414z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1294.1149902,766.4399414V625.0499268h-35.6599121v87.6620483l-56.4400635-87.6620483h-45.4599609 v141.3900146h35.8599854v-90.8950195l58.1999512,90.8950195H1294.1149902L1294.1149902,766.4399414z M1112.2751465,766.4399414 h40.5698242l-60.5599365-141.3900146h-46.6300049l-60.5529785,141.3900146h39.5830078l11.5599365-28.8839722h64.2800293 L1112.2751465,766.4399414L1112.2751465,766.4399414z M1087.9851074,706.8519287h-39.2000732L1068.3850098,658.375 L1087.9851074,706.8519287L1087.9851074,706.8519287z M972.3270264,657.7719116h38.0178833v-32.7219849h-40.7619019 c-44.4790039,0-68.3859863,29.4899902-68.3859863,69.684082v2.0219116c0,43.4250488,25.0830688,69.684021,65.6409912,69.684021 h2.940979l14.697937-31.7119141h-11.5609131c-22.5339966,0-35.8590088-13.736084-35.8590088-37.9721069v-2.0219116 C937.0570068,673.526001,948.8140869,657.7719116,972.3270264,657.7719116L972.3270264,657.7719116z M847.9400024,766.4399414 h35.8590088v-69.2520142v-72.1380005h-35.8590088v71.9700928V766.4399414L847.9400024,766.4399414z M842.2609863,766.4399414 l-45.8519897-51.507019c23.1220093-4.848938,37.0350342-22.2178955,37.0350342-44.2339478 c0-27.0670166-18.8140259-45.6490479-48.9880371-45.6490479h-78.5800171v141.3900146h35.8590088v-50.09198h13.9140625 l42.3249512,50.09198H842.2609863L842.2609863,766.4399414z M780.7310181,685.6449585h-38.9960327v-28.8839722h38.9960327 c10.9729614,0,16.657959,6.6660156,16.657959,14.5410156 C797.3889771,679.3829346,791.7039795,685.6449585,780.7310181,685.6449585L780.7310181,685.6449585z M570.2810059,766.4399414 h115.223999v-31.7119141h-79.3640137V710.690918h77.4030151v-30.9028931h-77.4030151v-23.0270386h79.3640137v-31.7110596 h-115.223999V766.4399414L570.2810059,766.4399414z M510.9140015,766.4399414h35.4680176V625.0499268h-56.4349976 l-31.5490112,90.2880859l-31.7460022-90.2880859h-57.0240173v141.3900146h35.4680176V661.8099976l37.2310181,104.6299438 h31.3559875l37.2309875-104.6299438V766.4399414L510.9140015,766.4399414z M325.3519897,766.4399414h40.5610046 l-60.5489807-141.3900146h-46.6389771l-60.5500488,141.3900146h39.5839844l11.5610352-28.8839722h64.2750244 L325.3519897,766.4399414L325.3519897,766.4399414z M301.0539551,706.8519287h-39.1919556L281.4570312,658.375 L301.0539551,706.8519287L301.0539551,706.8519287z"
  })))), /*#__PURE__*/React.createElement("i", {
    id: "adobe_illustrator_pgf"
  }));
};

const KlarnaLogo = _ref => {
  let {
    width,
    height,
    fill = "#ffb3c7",
    title
  } = _ref;
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 30",
    fill: fill,
    width: width,
    height: height
  }, /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("style", null, ".cls-1{fill:#ffb3c7;}")), /*#__PURE__*/React__default.createElement("g", {
    id: "Lager_2",
    "data-name": "Lager 2"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React__default.createElement("rect", {
    className: "cls-1",
    width: 100,
    height: 40.4494,
    rx: 11.7384
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M80.0772,17.7235a6.194,6.194,0,1,0,0,10.2373v.75h3.5145V16.9727H80.0772Zm-3.1964,8.1388a3.0243,3.0243,0,1,1,3.1849-3.02A3.1059,3.1059,0,0,1,76.8808,25.8623Z"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: 28.2027,
    y: 11.7416,
    width: 3.678,
    height: 16.9694
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M64.1542,16.6569a4.2694,4.2694,0,0,0-3.62,1.6383V16.9733h-3.5V28.711h3.5421V22.5424a2.4754,2.4754,0,0,1,2.6383-2.6591c1.5447,0,2.4325.9228,2.4325,2.6348V28.711h3.5107V21.2464C69.1577,18.5146,66.9857,16.6569,64.1542,16.6569Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M43,17.7235a6.194,6.194,0,1,0,0,10.2373v.75h3.5145V16.9727H43Zm-3.1965,8.1388a3.0243,3.0243,0,1,1,3.1845-3.02A3.1058,3.1058,0,0,1,39.8034,25.8623Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M51.9513,18.5017V16.9728H48.353V28.7111h3.606v-5.48c0-1.8491,2.0042-2.843,3.3949-2.843.014,0,.0276.0014.0417.0015V16.9735A4.3821,4.3821,0,0,0,51.9513,18.5017Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M87.323,24.5476a2.2059,2.2059,0,1,0,2.206,2.2059A2.2057,2.2057,0,0,0,87.323,24.5476Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M25.6675,11.7384H21.8558a9.7488,9.7488,0,0,1-3.9412,7.8678l-1.51,1.131,5.8513,7.9792h4.8106l-5.3837-7.342A13.5049,13.5049,0,0,0,25.6675,11.7384Z"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: 12.1204,
    y: 11.7384,
    width: 3.8185,
    height: 16.9773
  }))));
};

const KlarnaBWLogo = _ref => {
  let {
    width,
    height,
    title
  } = _ref;
  return /*#__PURE__*/React__default.createElement("svg", {
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 238.63 53.26",
    width: width,
    height: height
  }, /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("path", {
    d: "M42,0H30.25A30,30,0,0,1,18.11,24.23l-4.65,3.48,18,24.57H46.29L29.71,29.67A41.56,41.56,0,0,0,42,0Z"
  }), /*#__PURE__*/React__default.createElement("polygon", {
    points: "0 52.28 12.03 52.28 12.03 0 0 0 0 52.28 0 52.28"
  }), /*#__PURE__*/React__default.createElement("polygon", {
    points: "49.79 52.26 61.12 52.26 61.12 0.01 49.79 0.01 49.79 52.26 49.79 52.26"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M160.49,15.15c-4.32,0-8.41,1.34-11.14,5V16.12H138.57V52.26h10.91v-19c0-5.5,3.68-8.19,8.12-8.19,4.76,0,7.49,2.84,7.49,8.11V52.26H175.9v-23c0-8.41-6.69-14.13-15.41-14.13Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M85.51,43.49a9.56,9.56,0,0,1-9.8-9.3,9.82,9.82,0,0,1,19.61,0,9.56,9.56,0,0,1-9.81,9.3Zm9.84-27.37v2.31A19.07,19.07,0,1,0,84.63,53.26,18.89,18.89,0,0,0,95.35,50v2.31h10.83V16.12Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M122.92,20.83V16.12H111.84V52.26h11.1V35.39c0-5.7,6.17-8.76,10.46-8.76h.12V16.12c-4.39,0-8.43,1.88-10.6,4.71Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M199.68,43.49a9.56,9.56,0,0,1-9.8-9.3,9.82,9.82,0,0,1,19.61,0,9.56,9.56,0,0,1-9.81,9.3Zm9.85-27.37v2.31a19.07,19.07,0,1,0,0,31.52v2.31h10.82V16.12Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M231.84,39.44a6.8,6.8,0,1,0,6.79,6.8,6.79,6.79,0,0,0-6.79-6.8Z"
  }));
};

const ShipToAddressIcon = _ref => {
  let {
    width,
    height,
    fill,
    title
  } = _ref;
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 10 100 45",
    fill: fill,
    width: width,
    height: height
  }, /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M26.6,29.7H15.4v-2h11.2V29.7z M23.3,33.4H8.5v2h14.8V33.4z M20.2,39.1H2.1v2h18.1V39.1z M67.9,45.9h-4.8 c-0.5,2.4-2.6,4.3-5.2,4.3c-2.6,0-4.7-1.8-5.2-4.3H50h-1H33c-0.5,2.4-2.6,4.3-5.2,4.3s-4.7-1.8-5.2-4.3h-4.9v-2h4.9 c0.5-2.4,2.6-4.3,5.2-4.3s4.7,1.8,5.2,4.3h15V21.8H19.8v2.7h-2v-4.7H50v4.6h11.7l6.2,9.9V45.9z M31.1,44.9c0-1.8-1.5-3.3-3.3-3.3 s-3.3,1.5-3.3,3.3c0,1.8,1.5,3.3,3.3,3.3S31.1,46.7,31.1,44.9z M61.2,44.9c0-1.8-1.5-3.3-3.3-3.3s-3.3,1.5-3.3,3.3 c0,1.8,1.5,3.3,3.3,3.3S61.2,46.7,61.2,44.9z M65.9,34.9l-5.3-8.5H50v17.5h2.8c0.5-2.4,2.6-4.3,5.2-4.3c2.6,0,4.7,1.8,5.2,4.3h2.8 V34.9z"
  }))));
};

const ShippingMethodLoadingIcon = _ref => {
  let {
    width,
    height,
    fill,
    title
  } = _ref;
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 10 100 45",
    fill: fill,
    width: width,
    height: height
  }, /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M66.5,38.7l-6.2-9.9H48.6v-4.6H27.3c0.1,0.7,0.2,1.3,0.2,2h19.1v22.2h-15c-0.5-2.4-2.6-4.3-5.2-4.3s-4.7,1.8-5.2,4.3h-2.9 v-9.5c-0.6,0.2-1.3,0.3-2,0.4v11h4.9c0.5,2.4,2.6,4.3,5.2,4.3s4.7-1.8,5.2-4.3h16h1h2.8c0.5,2.4,2.6,4.3,5.2,4.3s4.7-1.8,5.2-4.3 h4.8V38.7z M26.5,52.6c-1.8,0-3.3-1.5-3.3-3.3c0-1.8,1.5-3.3,3.3-3.3s3.3,1.5,3.3,3.3C29.7,51.1,28.3,52.6,26.5,52.6z M56.6,52.6 c-1.8,0-3.3-1.5-3.3-3.3c0-1.8,1.5-3.3,3.3-3.3s3.3,1.5,3.3,3.3C59.8,51.1,58.4,52.6,56.6,52.6z M64.5,48.3h-2.8 c-0.5-2.4-2.6-4.3-5.2-4.3s-4.7,1.8-5.2,4.3h-2.8V30.8h10.6l5.3,8.5V48.3z M25.5,26.4c0-6.1-4.9-11-11-11s-11,4.9-11,11 s4.9,11,11,11S25.5,32.5,25.5,26.4z M14.5,35.5c-5,0-9-4-9-9s4-9,9-9s9,4,9,9S19.5,35.5,14.5,35.5z M11,26.4c0,0.6-0.5,1.1-1.1,1.1 s-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1S11,25.8,11,26.4z M15.6,26.4c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 c0-0.6,0.5-1.1,1.1-1.1C15.1,25.3,15.6,25.8,15.6,26.4z M20.2,26.4c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 c0-0.6,0.5-1.1,1.1-1.1C19.7,25.3,20.2,25.8,20.2,26.4z"
  }))));
};

const PickupIcon = _ref => {
  let {
    width,
    height,
    fill,
    title
  } = _ref;
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 50",
    fill: fill,
    width: width,
    height: height
  }, /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M53.5,27l-5.8-8.6c-0.2-0.3-0.5-0.4-0.8-0.4c0,0,0,0,0,0H23c0,0,0,0,0,0c-0.3,0-0.6,0.2-0.8,0.4L16.5,27 c-0.2,0.3-0.2,0.6,0,0.9c0.2,0.3,0.5,0.5,0.8,0.5c0,0,0,0,0,0h2.1v22.7c0,0.2,0.1,0.5,0.3,0.7c0.2,0.2,0.4,0.3,0.7,0.3H30 c0.5,0,0.9-0.4,1-0.9V35.4h8v15.6c0,0.2,0.1,0.5,0.3,0.7c0.2,0.2,0.4,0.3,0.6,0.3c0,0,0,0,0,0h9.6c0.3,0,0.5-0.1,0.7-0.3 c0.2-0.2,0.3-0.4,0.3-0.7V28.4h2.3c0,0,0,0,0,0c0.3,0,0.7-0.2,0.8-0.5C53.7,27.7,53.7,27.3,53.5,27z M40.5,33.9 c-0.2-0.2-0.4-0.3-0.7-0.3H30c-0.2,0-0.5,0.1-0.7,0.3c-0.2,0.2-0.3,0.4-0.3,0.7v15.6h-7.7V28.3h27.2v21.9h-7.7V34.5 C40.8,34.3,40.7,34,40.5,33.9z M50.8,26.4H19.2l4.4-6.5h22.8L50.8,26.4z"
  }))));
};

const IconList = _objectSpread2({
  email: EmailSVG,
  "secure-icon": SecureIconSVG,
  "question-mark": QuestionMarkSVG,
  "caret-down": CaretDownSVG,
  "success-icon": SuccessIconSVG,
  "info-icon": InformationIconSVG,
  "warning-icon": WarningIconSVG,
  "caution-icon": CautionIconSVG,
  star: StarSVG,
  "left-arrow": LeftArrowSVG,
  "right-arrow": RightArrowSVG,
  "up-arrow": UpArrowSVG,
  "down-arrow": DownArrowSVG,
  "plus-icon": PlusIconSVG,
  "minus-icon": MinusIconSVG,
  "remove-icon": RemoveIconSVG,
  user: UserIconSVG,
  "arcteryx-logo": ArcteryxLogo,
  "arcteryx-logo-no-text": ArcteryxLogoNoText,
  "arcteryx-logo-outlet": ArcteryxLogoOutlet,
  "google-pay-logo": GPayIcon,
  "apple-pay-logo": Icon$1,
  "paypal-logo": PayPalIcon,
  "visa-logo": VisaIcon,
  "amex-logo": SVGComponent,
  "klarna-logo": KlarnaLogo,
  "klarna-bw-logo": KlarnaBWLogo,
  "ship-to-address-icon": ShipToAddressIcon,
  "shipping-method-loading-icon": ShippingMethodLoadingIcon,
  "pickup-icon": PickupIcon,
  cart: CartSVG,
  link: LinkIconSVG
}, FlagIconList);

const Icon = _ref => {
  let {
    type,
    width,
    height,
    color,
    title
  } = _ref;
  const SVG = IconList[type];
  if (!SVG) {
    return Fragment;
  }
  return /*#__PURE__*/React__default.createElement(SVG, {
    width: width,
    height: height,
    fill: color,
    title: title
  });
};
Icon.displayName = "Icon";
Icon.defaultProps = {
  width: '100%',
  height: '100%',
  color: 'black',
  title: ''
};
Icon.propTypes = {
  type: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  color: PropTypes.string,
  title: PropTypes.string
};

export { Icon };
//# sourceMappingURL=index.js.map
